import React, { Component } from 'react';
import $, { type } from "jquery";
import config from "../config";
import { ApiClient } from "../libs/apiClient";
import { saveAs } from 'file-saver';
import {
    GroupCodeModal,
    CardCodeReferenceCreationModal,
    CardTypeModal,
    CurrencyModal,
    TerritoriesModal,
    ContactPersonsPartnerModal,
    AddressesPartnerModal,
    CountryModal,
    StatesModal,
    ImpuestoPartnerModal,
    PayMethodModal,
    BankAccountModal,
    ToolTip,
    StandardSelectModal,
    ProjectsPartnerModal,
} from "./index";
import EmployeeSalesPartnerModal from "./EmployeeSalesPartnerModal";
import GroupNumModal from "./GroupNumModal";
import PriceListPartnerModal from "./PriceListPartnerModal";
import UserFieldsPartnerModal from "./UserFieldsPartnerModal";
import { Addresses, ContactPersons, UserFields } from "./NewOrder";
import moment from 'moment';
import AccountBalancePartner from './AccountBalancePartner';
import AccountListPartnerModal from './AccountListPartnerModal';
import { CURRENCY, FORMAT_NUMBER, json, SERVICE_RESPONSE } from '../libs/utils/Const';
import '../css/fields.css';
import { ToolTips } from '../libs/utils/Const';
import SelectionMap from './SelectionMap';
import Select from 'react-select';

const RFC_FORMAT = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
const ZIPCODE = /^\d{5,5}$/;
let apiClient = ApiClient.getInstance();

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class BussinesPartnerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            groupCodes: [],
            cardTypes: [],
            currencies: [],
            employees: [],
            groupNums: [],
            prices: [],
            territories: [],
            contactPersons: [],
            addresses: [],
            countries: [],
            states: [],
            taxes: [],
            payMethods: [],
            addressesIndexSelected: null,
            countryIndexSelected: null,
            AccountBalan: [],
            CardCodeBalance: [],
            AccountBalanceData: {},
            cardCodeReferenceList: [],
            checkConso: false,
            accounts: [],
            accountMayorId: '',
            MajorAccounts: [],
            userConfigFieldsBP: JSON.parse(localStorage.getItem('userConfigFielsBP')) || null,
            groupCodesModal: false,
            showMap: false,
            currSelectionAddress: null,
            typeSelectionAddress: null,
            showTaxesModal: false,
            taxesModalInfo: {},
            uploadedDocuments: {},
            projects: [],
            glAccountsSelect: [],
            provinciasInvoices: [],
            provinciasDeliveries: [],
            distritosInvoices: [],
            distritosDeliveries: []
        };

        this.newModelCopy = '';
    }

    componentDidMount() {
        this._handelBack();
        // this.checkConfigFields('userConfigFielsBP', false);
        this.GetBankAccounts();
        this.loadExistingDocuments();
    }

    GetBankAccounts = async () => {
        const { enableSpinner, showAlert } = this.props;
        const search = {
            Type: 'BP'
        }
        enableSpinner(true);
        let responseApi = await apiClient.getCuentaMayor(search);
        enableSpinner(false);


        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        const glAccounts = responseApi?.data ?? [];

        const glAccountsSelect = glAccounts.map(acct => ({
            value: acct.AcctCode,
            label: `${acct.AcctCode} .- ${acct.AcctName}`,
            ...acct
        }));
        this.setState({ MajorAccounts: responseApi.data || [], glAccountsSelect })
    };

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }

    closeModal = () => {
        // this.checkConfigFields('userConfigFielsBP', false);
        this.forceUpdate()
        $('#BussinesPartner').modal('hide');
    }

    openAction = () => {
        let document = this;
        const { newOrderModel } = this.props;
        $('#BussinesPartner').on('hide.bs.modal', function () {
        });
    }

    ValidateLicTradNum = async () => {
        const { partnerModel } = this.props;
        let element = document.getElementById('rfcB');
        let icon = document.querySelector(`#grupo__rfcB i`);
        let text = document.querySelector(`#grupo__rfcB .form__input-error`);
        let require = document.querySelector(`#grupo__rfcB .form__input-void`);
        // console.log('job partnerModel', partnerModel.LicTradNum)
        // if (partnerModel.LicTradNum && partnerModel.LicTradNum != '') {
        //     if (!RFC_FORMAT.test(partnerModel.LicTradNum)) {
        //         element.classList.add('form__group-incorrect');
        //         element.classList.remove("form__group-correct");
        //         icon.classList.add('fa-times-circle');
        //         icon.classList.add('form__group-incorrect');
        //         icon.classList.remove('fa-check-circle');
        //         text.classList.add('form__input-error-active');
        //         require.classList.remove('form__input-void-active');
        //         return
        //     } else {
        //         element.classList.remove('form__group-incorrect');
        //         element.classList.add("form__group-correct");
        //         icon.classList.add('fa-check-circle');
        //         icon.classList.add('form__group-correct');
        //         icon.classList.remove('fa-times-circle');
        //         icon.classList.remove('form__group-incorrect');
        //         text.classList.remove('form__input-error-active');
        //         require.classList.remove('form__input-void-active');
        //     }
        // } else {
        //     element.classList.add('form__group-incorrect');
        //     element.classList.remove("form__group-correct");
        //     icon.classList.remove('fa-check-circle');
        //     require.classList.add('form__input-void-active');
        //     text.classList.remove('form__input-error-active');
        //     return
        // }
        return true
    }

    ValidateZipCodeShip = async () => {
        const { partnerModel, } = this.props;
        const { DeliveriesAddress, deliveriesAddressEditIndex } = partnerModel;
        let deliveriesAddress = deliveriesAddressEditIndex != null ? DeliveriesAddress[deliveriesAddressEditIndex] : {};
        let element = document.getElementById('input__BDA9');
        let icon = document.querySelector(`#BDA9 i`);
        let text = document.querySelector(`#grupo__BDA9 .form__input-error`);
        let require = document.querySelector(`#grupo__BDA9 .form__input-void`);

        if (!element || !icon || !text || !require) {
            return true;
        }

        if (!deliveriesAddress.ZipCode == "") {
            if (!ZIPCODE.test(deliveriesAddress.ZipCode)) {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
                return
            } else {
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }

        return true
    }

    ValidateZipCodeBill = async () => {
        return true
        const { partnerModel, } = this.props;
        const { InvoicesAddress, invoicesAddressEditIndex } = partnerModel;
        if (InvoicesAddress.length > 0) {
            let invoicesAddress = invoicesAddressEditIndex != null ? InvoicesAddress[invoicesAddressEditIndex] : {};
            let element = document.getElementById('input__BPIA6');
            let icon = document.querySelector(`#BPIA6 i`);
            let text = document.querySelector(`#grupo__BPIA6 .form__input-error`);
            let require = document.querySelector(`#grupo__BPIA6 .form__input-void`);

            if (!invoicesAddress.ZipCode == "") {
                if (!ZIPCODE.test(invoicesAddress.ZipCode)) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    icon.classList.add('fa-times-circle');
                    icon.classList.add('form__group-incorrect');
                    icon.classList.remove('fa-check-circle');
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    return
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    icon.classList.add('fa-check-circle');
                    icon.classList.add('form__group-correct');
                    icon.classList.remove('fa-times-circle');
                    icon.classList.remove('form__group-incorrect');
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                }
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.remove('fa-check-circle');
                require.classList.add('form__input-void-active');
                text.classList.remove('form__input-error-active');
                return
            }
        }
        return true
    }

    validateFields = () => {
        const { partnerModel, showAlert } = this.props;
        const { contactPersons, addresses } = this.state;

        if (!partnerModel.Phone1 || partnerModel.Phone1.trim() === "") {
            showAlert({ type: 'warning', message: 'Debe ingresar un número de teléfono.', timeOut: 5000 })
            return false;
        }

        if (!/^\d{1,9}$/.test(partnerModel.Phone1)) {
            showAlert({ type: 'warning', message: 'El Teléfono debe contener solo números y máximo 9 dígitos.', timeOut: 5000 })
            return false;
        }

        if (!partnerModel.E_mail || partnerModel.E_mail.trim() === "") {
            showAlert({ type: 'warning', message: 'Debe ingresar un correo electrónico.', timeOut: 5000 })
            return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(partnerModel.E_mail)) {
            showAlert({ type: 'warning', message: 'El correo no debe ir vacío y debe contener @.', timeOut: 5000 })
            return false;
        }

        if (!partnerModel.FatherType || (partnerModel?.FatherType ?? '') == '') {
            showAlert({ type: 'warning', message: 'Debe indicar el Tipo de consolidación en la pestaña "Finanzas/General."', timeOut: 5000 })
            return false
        } else if (!partnerModel.VatStatus || (partnerModel?.VatStatus ?? '') == '') {
            showAlert({ type: 'warning', message: 'Debe indicar el impuesto en la pestaña "Finanzas/Impuesto".', timeOut: 5000 })
            return false
        } else if (!partnerModel.GroupCode || (partnerModel?.GroupCode ?? '') == '') {
            showAlert({ type: 'warning', message: 'Debe indicar el GRUPO.' })
            return false
        } else if (!partnerModel.Currency || (partnerModel?.Currency ?? '') == '') {
            showAlert({ type: 'warning', message: 'Debe indicar la MONEDA.' })
            return false
        } else if (!partnerModel.PriceListNum || (partnerModel?.PriceListNum ?? '') == '') {
            showAlert({ type: 'warning', message: 'Debe indicar una lista de precios en la pestaña "Condición Pago".', timeOut: 5000 })
            return false
        } else if (!partnerModel.SlpCode || (partnerModel?.SlpCode ?? '') == '') {
            showAlert({ type: 'warning', message: 'Seleccione un empleado de ventas en la pestaña "General".', timeOut: 5000 })
            return false
        }

        // PERSONAS DE CONTACTO
        if (contactPersons && contactPersons.length > 0) {
            for (let i = 0; i < contactPersons.length; i++) {
                const contact = contactPersons[i];
                if (!contact.Name || contact.Name.trim() === '') {
                    showAlert({ type: 'warning', message: `Persona de Contacto #${i + 1}: El ID de contacto es obligatorio.`, timeOut: 5000 });
                    return false;
                }
            }
        }

        if (!partnerModel.InvoicesAddress || partnerModel.InvoicesAddress.length === 0) {
            showAlert({ type: 'warning', message: 'No puedes crear ni editar SN si no tienes dirección de facturación.', timeOut: 5000 });
            return false;
        }

        // DIRECCIONES
        if (addresses && addresses.length > 0) {
            // Direcciones de Facturación
            const invoiceAddresses = addresses.filter(addr => addr.AddressType === 'bo_BillTo');
            for (let i = 0; i < invoiceAddresses.length; i++) {
                const addr = invoiceAddresses[i];
                if (!addr.Address || addr.Address.trim() === '') {
                    showAlert({ type: 'warning', message: `Dirección de Facturación #${i + 1}: El Alias es obligatorio.`, timeOut: 5000 });
                    return false;
                }
            }

            // Direcciones de Entrega
            const deliveryAddresses = addresses.filter(addr => addr.AddressType === 'bo_ShipTo');
            for (let i = 0; i < deliveryAddresses.length; i++) {
                const addr = deliveryAddresses[i];
                if (!addr.Address || addr.Address.trim() === '') {
                    showAlert({ type: 'warning', message: `Dirección de Entrega #${i + 1}: El Alias es obligatorio.`, timeOut: 5000 });
                    return false;
                }
            }
        }

        if (!partnerModel?.CardType) {
            showAlert({ type: 'warning', message: `Seleccione un Tipo de Socio de Negocios válido`, timeOut: 5000 });
            return false;
        }
        if (['C', 'L']?.includes(partnerModel.CardType ?? '') && (!partnerModel?.SlpCode || Number(partnerModel?.SlpCode) === -1)) {
            showAlert({ type: 'warning', message: `Cliente o Lead debe tener asociado un empleado de ventas`, timeOut: 5000 });
            return false;
        }

        if (Array.isArray(partnerModel.InvoicesAddress)) {
            for (const invoice of partnerModel.InvoicesAddress) {
                if (!invoice.ZipCode || invoice.ZipCode.toString().trim() === '') {
                    showAlert({ type: 'warning', message: `Dirección de Facturación "${invoice.Address}" no cuenta con ubigeo`, timeOut: 5000 });
                    return false;
                }
            }
        }

        if (Array.isArray(partnerModel.DeliveriesAddress)) {
            for (const delivery of partnerModel.DeliveriesAddress) {
                if (!delivery.ZipCode || delivery.ZipCode.toString().trim() === '') {
                    showAlert({ type: 'warning', message: `Dirección de Entrega "${delivery.Address}" no cuenta con ubigeo`, timeOut: 5000 });
                    return false;
                }
            }
        }

        if (partnerModel?.InvoicesAddress?.length && !partnerModel?.BillToDef) {
            showAlert({ type: 'warning', message: `Debe fijar como estándar una dirección de facturación`, timeOut: 5000 });
            return false;
        }

        if (partnerModel?.InvoicesAddress?.length && partnerModel?.BillToDef && !partnerModel?.InvoicesAddress?.some(addr => addr.Address === partnerModel.BillToDef)) {
            showAlert({ type: 'warning', message: `La dirección de facturación marcada como estándar ya no coincide con las direcciones actuales. Por favor, vuelva a establecer una dirección de facturación como estándar.`, timeOut: 10000 });
            return false;
        }

        if (partnerModel?.DeliveriesAddress?.length && !partnerModel?.ShipToDef) {
            showAlert({ type: 'warning', message: `Debe fijar como estándar una dirección de entrega`, timeOut: 5000 });
            return false;
        }

        if (partnerModel?.DeliveriesAddress?.length && partnerModel?.ShipToDef && !partnerModel?.DeliveriesAddress?.some(addr => addr.Address === partnerModel.ShipToDef)) {
            showAlert({ type: 'warning', message: `La dirección de entrega marcada como estándar ya no coincide con las direcciones actuales. Por favor, vuelva a establecer una dirección de entrega como estándar`, timeOut: 10000 });
            return false;
        }

        return true;
    }

    ValidateAll = async (action) => {
        // this.ValidateZipCodeBill()
        // this.ValidateLicTradNum()
        if (await this.validateFields() == true && await this.ValidateZipCodeBill() == true && await this.ValidateLicTradNum() == true) {
            action()
        }

    }
    validateBPModal = () => {
        const { partnerModel, showAlert } = this.props;
        let isValidData = true;
        // showAlert({ type: "warning", message: "FORCED ERROR" });
        return isValidData;
    }


    sendModel = async () => {
        const { sendModel, partnerModel, enableSpinner, showAlert } = this.props;
        if (this.validateBPModal() && this.validateFields()) {
            let modelToSave = JSON.parse(JSON.stringify(partnerModel));
            //#region Revisar Latitud y Longitud
            for (const delivery of modelToSave?.DeliveriesAddress) {
                delivery.U_FMB_GPSLat = this.sanitizeInteger(delivery.U_FMB_GPSLat);
                delivery.U_FMB_GPSLon = this.sanitizeInteger(delivery.U_FMB_GPSLon);
            }
            for (const invoice of modelToSave?.InvoicesAddress) {
                invoice.U_FMB_GPSLat = this.sanitizeInteger(invoice.U_FMB_GPSLat);
                invoice.U_FMB_GPSLon = this.sanitizeInteger(invoice.U_FMB_GPSLon);
            }
        //#endregion Revisar Latitud y Longitud

            for (let i = 1; i <= 6; i++) {
                const fieldName = `U_RS_Doc${i}`;
                const fileValue = partnerModel[fieldName];
                if (fileValue instanceof File) {
                    try {
                        enableSpinner(true);
                        const response = await apiClient.uploadAttachmentFile(fileValue);
                        enableSpinner(false);
                        if (response && response.status === SERVICE_RESPONSE.SUCCESS && response.data) {
                            modelToSave[fieldName] = response.data;
                            showAlert({ type: "success", message: `Archivo ${fileValue.name} subido correctamente` });
                        } else {
                            throw new Error(response?.message || 'Error en upload');
                        }
                    } catch (error) {
                        showAlert({ type: "error", message: `Error al subir ${fileValue.name}` });
                        return;
                    }
                }
            }
            sendModel(modelToSave);
        }
    }

    acceptEditMode = async () => {
        const { acceptEditMode, sendAuthModel, partnerModel, enableSpinner, showAlert } = this.props;
        const { partnerModelBackup } = this.state;
        let modelToSave = JSON.parse(JSON.stringify(partnerModel));
        //#region Revisar Latitud y Longitud
        for (const delivery of modelToSave?.DeliveriesAddress) {
            delivery.U_FMB_GPSLat = this.sanitizeInteger(delivery.U_FMB_GPSLat);
            delivery.U_FMB_GPSLon = this.sanitizeInteger(delivery.U_FMB_GPSLon);
        }
        for (const invoice of modelToSave?.InvoicesAddress) {
            invoice.U_FMB_GPSLat = this.sanitizeInteger(invoice.U_FMB_GPSLat);
            invoice.U_FMB_GPSLon = this.sanitizeInteger(invoice.U_FMB_GPSLon);
        }
        //#endregion Revisar Latitud y Longitud
        const uploadedDocs = { ...this.state.uploadedDocuments };

        for (let i = 1; i <= 6; i++) {
            const fieldName = `U_RS_Doc${i}`;
            const fileValue = partnerModel[fieldName];

            if (fileValue instanceof File) {
                try {
                    enableSpinner(true);
                    const response = await apiClient.uploadAttachmentFile(fileValue);
                    enableSpinner(false);
                    if (response && response.status === SERVICE_RESPONSE.SUCCESS && response.data) {
                        modelToSave[fieldName] = response.data;
                        uploadedDocs[fieldName] = {
                            fileName: fileValue.name,
                            filePath: response.data,
                            uploaded: true
                        };
                        showAlert({ type: "success", message: `Archivo ${fileValue.name} subido correctamente` });
                    } else {
                        throw new Error(response?.message || 'Error desconocido en upload');
                    }
                } catch (error) {
                    showAlert({ type: "error", message: `Error al subir el archivo ${fileValue.name}: ${error.message}` });
                    return;
                }
            } else {
                modelToSave[fieldName] = partnerModel[fieldName];
                if (partnerModel[fieldName] && partnerModel[fieldName] !== '') {
                    uploadedDocs[fieldName] = {
                        fileName: partnerModel[fieldName].split('\\').pop() || `Documento${i}`,
                        filePath: partnerModel[fieldName],
                        uploaded: true
                    };
                }
            }
        }
        for (let i = 1; i <= 6; i++) {
            const fieldName = `U_RS_Doc${i}`;
        }
        this.setState({ uploadedDocuments: uploadedDocs });
        
        enableSpinner(true);
        const response = await apiClient.getBPListProps();
        enableSpinner(false);

        if (this.authModel(modelToSave, JSON.parse(partnerModelBackup), response?.data?.whiteList, response?.data?.balckList)) {
            sendAuthModel(modelToSave);
        } else {
            acceptEditMode(modelToSave);
        }
    }

    cancelEditMode = () => {
        const { cancelEditMode } = this.props;
        cancelEditMode();
        this.setState({
            editMode: false,
            partnerModelBackup: null,
        });
        // this.checkConfigFields('userConfigFielsBP', false);
        this.forceUpdate()
    }

    editMode = () => {
        const { partnerModel } = this.props;
        this.setState({
            partnerModelBackup: JSON.stringify(partnerModel),
            editMode: !this.state.editMode,
        });
        // console.log('job this.state.editMode', this.state.editMode)
        // if (this.state.editMode == true){
        // console.log('job',"entro")
        // this.checkConfigFields('userConfigFielsBP', true);
        this.forceUpdate()
        // }
    }

    authModel = (current, before, whiteList, blackList) => {
        let validatedProps = [];
        if (Array.isArray(whiteList) && whiteList?.length) {
            for (const { prop } of whiteList) {
                if (before.hasOwnProperty(prop) || current.hasOwnProperty(prop)) {
                    if (this.validateChanges(current[prop], before[prop], whiteList, blackList)) return true;
                }
            }
        } else {
            for (const prop in before) {
                validatedProps.push(prop);

                if (Array.isArray(blackList) && blackList.length) {
                    if (blackList.some(({ bannedProp })=> bannedProp === prop)) continue;
                }

                if (this.validateChanges(current[prop], before[prop], whiteList, blackList)) return true;
            }
            for (const prop in current) {
                if (validatedProps.some((validatedProp) => validatedProp === prop)) continue;

                if (Array.isArray(blackList) && blackList.length) {
                    if (blackList.some(({ bannedProp })=> bannedProp === prop)) continue;
                }

                if (this.validateChanges(current[prop], before[prop], whiteList, blackList)) return true;
            }
        }

        return false;
    }

    validateChanges = (current, before, whiteList, blackList) => {
        if (typeof(before) !== "object" || typeof(current) !== "object") {
            return before !== current;
        } else if (Array.isArray(before) || Array.isArray(current)) {
            if (Array.isArray(before) && Array.isArray(current)) {
                if (before.length === current.length) {
                    for (let i = 0; i < before.length; i++) {
                        if (this.validateChanges(before[i], current[i])) return true;
                    }
                } else {
                    return true;
                }
            }
        } else {
            let validatedProps = [];
            if (Array.isArray(whiteList) && whiteList?.length) {
                for (const { prop } of whiteList) {
                    if (before.hasOwnProperty(prop) || current.hasOwnProperty(prop)) {
                        if (this.validateChanges(current[prop], before[prop], whiteList, blackList)) return true;
                    }
                }
            } else {
                for (const prop in before) {
                    validatedProps.push(prop);

                    if (Array.isArray(blackList) && blackList.length) {
                        if (blackList.some(({ bannedProp })=> bannedProp === prop)) continue;
                    }

                    if (this.validateChanges(current[prop], before[prop], whiteList, blackList)) return true;
                }
            }
        }
        return false;
    }

    deleteBank = (deleteBank) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === deleteBank.AbsEntry) {

                partnerModel.BankAccounts.splice(index, 1);
            }

        }

        this.refreshModel(partnerModel);
    }

    changeAccountBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {

            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.Account = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeControlKeyBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.ControlKey = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeBranchBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.Branch = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeIBANBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.IBAN = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeSwiftNumBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.SwiftNum = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    selectBankDefault = (newBankModel) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {

            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === newBankModel.AbsEntry) {
                partnerModel.DefaultBankCode = BankAccountModel.BankCode || ''; //015
                partnerModel.BankCountr = BankAccountModel.Country; //Mexico
                partnerModel.BankCode = BankAccountModel.BankName; //BBVA
                partnerModel.DflAccount = BankAccountModel.Account;
                partnerModel.DflSwift = BankAccountModel.SwiftNum;
                partnerModel.DflBranch = BankAccountModel.Branch;
                partnerModel.BankCtlKey = BankAccountModel.ControlKey;
                partnerModel.DflIBAN = BankAccountModel.IBAN;
            }
        }

        this.refreshModel(partnerModel);

        $('#bankAccountModal').modal('hide');
    }

    changeBusinessPartnerCardCode = event => {
        return
        const { partnerModel } = this.props;
        partnerModel.CardCode = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    }

    changeBusinessPartnerCardName = event => {
        const { partnerModel } = this.props;
        const value = event.nativeEvent.target.value;

        if (value.length > 100) {
            partnerModel.CardName = value.substring(0, 100);
            partnerModel.U_FMB_AUX_CARDNAME = value;
        } else {
            partnerModel.CardName = value;
            partnerModel.U_FMB_AUX_CARDNAME = '';
        }

        this.refreshModel(partnerModel);
    }

    changeBusinessPartnerLicTradNum = event => {
        const { partnerModel, action } = this.props;
        partnerModel.LicTradNum = event.nativeEvent.target.value;
        if (action === 1) this.generateCardCode(partnerModel)
        this.refreshModel(partnerModel);
    }

    changeBusinessPartnerPhone1 = event => {
        const value = event.nativeEvent.target.value;
        const { partnerModel } = this.props;
        if (/^\d{0,9}$/.test(value)) {
            partnerModel.Phone1 = value;
            this.refreshModel(partnerModel);
        }
    }

    changeBusinessPartnerPhone2 = event => {
        const value = event.nativeEvent.target.value;
        const { partnerModel } = this.props;
        if (/^\d{0,9}$/.test(value)) {
            partnerModel.Phone2 = value;
            this.refreshModel(partnerModel);
        }

    }

    changeCorreo = event => {
        const { partnerModel } = this.props;
        partnerModel.E_mail = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    }

    changeCreditLine = event => {
        const { partnerModel } = this.props;
        let valueOrg = event.nativeEvent.target.value;
        let value = (event.nativeEvent.target.value).replace(/[A-Z]+/g, "").replace(/\,+/g, "");
        if (value.trim() === "." || value.trim() === "") { value = "0." }

        if (!isNaN(value)) {
            partnerModel.CreditLine = Number(value);
            partnerModel.CreditLineShow = valueOrg.trim();
            this.refreshModel(partnerModel);
        }
    }

    validateCreditLineNull = () => {
        const { partnerModel } = this.props;
        let value = (partnerModel.CreditLineShow || "").replace("SOL", "").replace(/\,+/g, "");
        let debitValue = partnerModel.DebtLine;

        if (isNaN(value)) { partnerModel.CreditLine = 0; }
        else if (Number(value) > Number(debitValue)) { partnerModel.DebtLine = Number(value); }

        partnerModel.CreditLineShow = FORMAT_NUMBER.new(partnerModel.CreditLine, CURRENCY + " ");
        partnerModel.DebtLineShow = FORMAT_NUMBER.new(partnerModel.DebtLine, CURRENCY + " ");

        this.refreshModel(partnerModel);
    }

    changeDebitLine = event => {
        const { partnerModel } = this.props;
        let valueOrg = event.nativeEvent.target.value;
        let value = (event.nativeEvent.target.value).replace(/[A-Z]+/g, "").replace(/\,+/g, "");
        if (value.trim() === "." || value.trim() === "") { value = "0." }

        if (!isNaN(value)) {
            partnerModel.DebtLine = Number(value);
            partnerModel.DebtLineShow = valueOrg.trim();
            this.refreshModel(partnerModel);
        }
    }

    validateDebitLineNull = () => {
        const { partnerModel, showAlert } = this.props;
        let value = (partnerModel.DebtLineShow || "").replace("SOL", "").replace(/\,+/g, "");
        let creditValue = partnerModel.CreditLine;

        if (isNaN(value)) { partnerModel.DebtLine = 0; }
        else if (Number(value) < Number(creditValue)) {
            showAlert({ type: "warning", message: "El valor debe ser mayor o igual al limite de crédito" });
            partnerModel.DebtLine = Number(creditValue);
        }

        partnerModel.DebtLineShow = FORMAT_NUMBER.new(partnerModel.DebtLine, CURRENCY + " ");

        this.refreshModel(partnerModel);
    }

    changeIDContacto = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Name = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeFirstName = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].FirstName = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeTitle = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Title = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeMiddleName = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].MiddleName = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changePosition = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Position = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeLastName = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].LastName = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeTel1 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Tel1 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeTel2 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Tel2 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeCellolar = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Cellolar = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeFax = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Fax = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeE_mail = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].E_MailL = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeNotes1 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Notes1 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeNotes2 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Notes2 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeActiveContact = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Active = event.target.checked ? 'Y' : 'N';
        }

        this.refreshModel(partnerModel);
    }

    changeAddress = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Address = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeEmailGroup = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].EmlGrpCode = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changePager = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Pager = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changePassword = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;
        let value = event.nativeEvent.target.value ?? '';
        value = value?.slice(0, 30);

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Password = value;
        }

        this.refreshModel(partnerModel);
    }


    changeProfession = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Profession = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }


    changeGender = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Gender = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeBirthDate = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].DateOfBirth = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeAval = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].U_AvalSN = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    }

    changeContactAddress = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            if (!partnerModel.ContactPersons[contactEditIndex]) {
                partnerModel.ContactPersons[contactEditIndex] = new ContactPersons();
            }

            partnerModel.ContactPersons[contactEditIndex].Address = event.nativeEvent.target.value;
            this.refreshModel(partnerModel);
        }
    }

    changeContactDefault = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.CntctPrsn = partnerModel.ContactPersons[contactEditIndex].Name;
        }

        this.refreshModel(partnerModel);
    }

    changeRefDetails = event => {
        const { partnerModel } = this.props;
        if (event.nativeEvent.data != ' ') {
            partnerModel.RefDetails = event.nativeEvent.target.value;
        }
        this.refreshModel(partnerModel);
    }

    refreshModel = partnerModel => {
        const { refreshModel } = this.props;
        refreshModel(partnerModel);
    }

    ChangeDpmClear = (value) => {
        const { partnerModel } = this.props;
        partnerModel.DownPaymentClearAct = value;
        this.refreshModel(partnerModel);
    }

    ChangeDpmIntAct = (value) => {
        const { partnerModel } = this.props;
        partnerModel.DownPaymentInterimAccount = value;
        this.refreshModel(partnerModel);
    }

    changeAddress = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type === 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Address = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Address = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    }

    changeStreet = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Street = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Street = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    }

    changeBlock = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Block = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Block = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    }

    changeCity = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].City = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].City = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    changeZipCode = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].ZipCode = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].ZipCode = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    changeCounty = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].County = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].County = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    openState = async type => {
        const { showAlert, partnerModel, enableSpinner, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        enableSpinner(true);
        let groupCodeResponse = await apiClient.getState();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        let country = '';
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                country = partnerModel.InvoicesAddress[invoicesAddressEditIndex].Country;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                country = partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Country;
            }
        }


        let states = [];

        groupCodeResponse.data.map(state => {
            //console.log("dfsdfsdf", country, state.Country);
            if (state.Country == country) {
                states.push(state)
            }
        });


        if (states.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar con el País seleccionado' });
            return;
        }

        this.setState({
            states: states,
            countryIndexSelected: type,
        });

        $('#statesModal').modal('show');
    }

    selectState = async action => {
        const { states, countryIndexSelected } = this.state;
        let state = states[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, enableSpinner } = this.props;
        if (countryIndexSelected == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].State = state.Code;
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].County = state.Name;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].State = state.Code;
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].County = state.Name;
            }
        }
        this.refreshModel(partnerModel);

        enableSpinner(true);
        const country = countryIndexSelected == 'invoices'
            ? partnerModel.InvoicesAddress[invoicesAddressEditIndex].Country
            : partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Country;

        const data = {
            code: state.Code,
            country: country
        };

        const provinciaResponse = await apiClient.getProvincias(data);
        enableSpinner(false);

        if (Array.isArray(provinciaResponse.data) && provinciaResponse.data.length > 0) {
            // Version 1
            // const stateKey = countryIndexSelected === 'invoices' ? 'provinciasInvoices' : 'provinciasDeliveries';
            // this.setState({
            //     [stateKey]: provinciaResponse.data
            // });
            if (countryIndexSelected === 'invoices' && invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].provinciasInvoices = provinciaResponse.data || [];
            } else if (countryIndexSelected === 'deliveries' && deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].provinciasDeliveries = provinciaResponse.data || [];
            }
            await this.refreshModel(partnerModel);
        }

        $('#statesModal').modal('hide');

        if (['invoices', 'deliveries'].includes(countryIndexSelected) && state.Name) {
            const existInProvincias = provinciaResponse?.data?.some(row => row.U_RS_PROVINCIA === state.Name);
            if (existInProvincias) {
                setTimeout(() => {
                    this.handleProvinciaChange({ target: { value: state.Name } }, countryIndexSelected);
                }, 500);
            } else {
                const addressType = countryIndexSelected === 'invoices' ? 'InvoicesAddress' : 'DeliveriesAddress';
                const addressIndex = countryIndexSelected === 'invoices' ? invoicesAddressEditIndex : deliveriesAddressEditIndex;

                if (addressIndex != null) {
                    partnerModel[addressType][addressIndex].County = '';
                    partnerModel[addressType][addressIndex].City = '';
                    partnerModel[addressType][addressIndex].ZipCode = '';
                    if (addressType === 'InvoicesAddress') {
                        partnerModel[addressType][addressIndex].distritosInvoices = [];
                    } else {
                        partnerModel[addressType][addressIndex].distritosDeliveries = [];
                    }
                }
                await this.refreshModel(partnerModel);
            }
        }

    }

    openCountry = async type => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getCountry();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            countries: groupCodeResponse.data,
            countryIndexSelected: type,
        });

        $('#countryModal').modal('show');
    }

    selectCountry = action => {
        const { countries, countryIndexSelected } = this.state;
        let country = countries[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (countryIndexSelected === 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Country = country.Code;
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].State = '';
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].County = '';
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].City = '';
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Block = '';
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].ZipCode = '';
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Country = country.Code;
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].State = '';
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].County = '';
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].City = '';
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Block = '';
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].ZipCode = '';
            }
        }

        this.refreshModel(partnerModel);
        this.setState({
            provincias: [],
            distritos: []
        });
        $('#countryModal').modal('hide');
    }


    handleProvinciaChange = async (event, type) => {
        const provincia = event.target.value;
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, enableSpinner } = this.props;

        if (type === 'invoices' && invoicesAddressEditIndex != null) {
            partnerModel.InvoicesAddress[invoicesAddressEditIndex].County = provincia;
            partnerModel.InvoicesAddress[invoicesAddressEditIndex].City = '';
            partnerModel.InvoicesAddress[invoicesAddressEditIndex].ZipCode = '';
            if (!provincia) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].distritosInvoices = []
            }
        } else if (type === 'deliveries' && deliveriesAddressEditIndex != null) {
            partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].County = provincia;
            partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].City = '';
            partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].ZipCode = '';
            if (!provincia) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].distritosDeliveries = []
            }
        }
        this.refreshModel(partnerModel);

        enableSpinner(true);
        const address = type === 'invoices'
            ? partnerModel.InvoicesAddress[invoicesAddressEditIndex]
            : partnerModel.DeliveriesAddress[deliveriesAddressEditIndex];

        const data = {
            code: address.State,
            country: address.Country,
            provincia: provincia
        };

        const distritosResponse = await apiClient.getDistritos(data);
        enableSpinner(false);

        if (Array.isArray(distritosResponse.data) && distritosResponse.data.length > 0) {
            // Version 1
            // const stateKey = type === 'invoices' ? 'distritosInvoices' : 'distritosDeliveries';
            // this.setState({
            //     [stateKey]: distritosResponse.data
            // });
            if (type === 'invoices' && invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].distritosInvoices = distritosResponse.data || [];
            } else if (type === 'deliveries' && deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].distritosDeliveries = distritosResponse.data || [];
            }
            await this.refreshModel(partnerModel);
        }
    }

    handleDistritoChange = async (event, type) => {
        const distrito = event.target.value;
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, enableSpinner } = this.props;

        if (type === 'invoices' && invoicesAddressEditIndex != null) {
            partnerModel.InvoicesAddress[invoicesAddressEditIndex].City = distrito;
            if (!distrito) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].ZipCode = '';
            }
        } else if (type === 'deliveries' && deliveriesAddressEditIndex != null) {
            partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].City = distrito;
            if (!distrito) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].ZipCode = '';
            }
        }
        this.refreshModel(partnerModel);

        enableSpinner(true);
        const address = type === 'invoices'
            ? partnerModel.InvoicesAddress[invoicesAddressEditIndex]
            : partnerModel.DeliveriesAddress[deliveriesAddressEditIndex];

        const data = {
            code: address.State,
            country: address.Country,
            provincia: address.County,
            distrito: distrito
        };

        const ubigeoResponse = await apiClient.getUbigeo(data);
        enableSpinner(false);

        if (Array.isArray(ubigeoResponse.data) && ubigeoResponse.data.length > 0) {
            if (type === 'invoices' && invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].ZipCode = ubigeoResponse.data[0].Code;
            } else if (type === 'deliveries' && deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].ZipCode = ubigeoResponse.data[0].Code;
            }
            this.refreshModel(partnerModel);
        }
    }

    changePartnerActive = value => {
        const { partnerModel } = this.props;
        partnerModel.validFor = value;
        this.refreshModel(partnerModel);
    }

    openPayMethod = async type => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.payMethod();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            payMethods: groupCodeResponse.data,
        });

        $('#payMethodsModal').modal('show');
    }

    selectPayMethod = action => {
        let { partnerModel } = this.props;
        const { payMethods } = this.state;
        let payMethod = payMethods[action.index];
        let newMethod = [];

        newMethod.push({ PymCode: payMethod.PayMethCod });
        partnerModel.PymCode = payMethod.PayMethCod;
        partnerModel.PymCodeName = payMethod.Descript;

        partnerModel.PayMethodCodes = newMethod;
        this.refreshModel(partnerModel);
        $('#payMethodsModal').modal('hide');
    }

    openTaxes = async type => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getTaxesList();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            taxes: groupCodeResponse.data,
            countryIndexSelected: type,
        });

        $('#taxesPartnerModal').modal('show');
    }

    openProjects = async type => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        if (!partnerModel?.CardCode) {
            showAlert({ type: 'error', message: 'Es necesario el código del socio de negocios' });
            return;
        }

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getProjectsListByPartner(partnerModel?.CardCode);
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse?.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            projects: groupCodeResponse?.data || [],
            countryIndexSelected: type,
        });

        $('#projectsPartnerModal').modal('show');
    }

    selectTaxes = action => {
        const { taxes, countryIndexSelected } = this.state;
        let taxe = taxes[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (countryIndexSelected == 'invoices') {
            if (invoicesAddressEditIndex != null) {
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].TaxCode = taxe.Code;
            }
        }
        partnerModel.TaxCode = taxe.Code || '';
        partnerModel.TaxName = taxe.Name || '';

        this.refreshModel(partnerModel);
        $('#taxesPartnerModal').modal('hide');
    }

    selectProject = action => {
        const { projects, countryIndexSelected } = this.state;
        let project = projects[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (countryIndexSelected == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].U_FMB_Project = project.PrjCode;
            }
        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].U_FMB_Project = project.PrjCode;
            }
        }

        this.refreshModel(partnerModel);
        $('#projectsPartnerModal').modal('hide');
    }

    changeBuilding = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Building = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Building = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    changeTaxOffice = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].TaxOffice = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].TaxOffice = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    changeStreetNo = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].StreetNo = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].StreetNo = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    changeGlblLocNum = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].GlblLocNum = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].GlblLocNum = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    }

    changeAddressDefault = (type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        let isDefaultAddressSet = false;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.BillToDef = partnerModel.InvoicesAddress[invoicesAddressEditIndex].Address;
                isDefaultAddressSet = partnerModel.BillToDef ? true : false;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.ShipToDef = partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Address;
                isDefaultAddressSet = partnerModel.ShipToDef ? true : false
            }
        }

        this.refreshModel(partnerModel);
        if (isDefaultAddressSet) showAlert({ type: 'info', message: 'Dirección por defecto establecida correctamente', timeOut: 5000 });
    }

    openCardType = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        this.setState({
            cardTypes: [
                { code: 'C', name: 'Cliente' },
                { code: 'S', name: 'Proveedor' },
                { code: 'L', name: 'Lead' },
            ],
        });

        setTimeout(() => {
            $('#cardTypeModal').modal('show');
        }, 100)

    }

    getBusinessPartnerCode = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        if (partnerModel.CardType === '') {
            showAlert({ type: 'warning', message: 'Selecciona el tipo de socio de negocios para encontrar coincidencias' });
            return;
        }

        let filter = {
            cardCodeReference: partnerModel.CardCode || '',
            cardType: partnerModel.CardType || ''
        }

        enableSpinner(true);
        let businesPartnerResponse = await apiClient.getPartnerList(filter);
        enableSpinner(false);


        if (!Array.isArray(businesPartnerResponse.data.partners)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (businesPartnerResponse.data.partners.length === 0) {
            showAlert({ type: 'info', message: 'No existen coincidencias con su código de socio' });
            return;
        }

        this.setState({
            cardCodeReferenceList: businesPartnerResponse.data.partners,
        });

        $('#cardCodeReferenceCreationModal').modal('show');
    }

    selectCardType = async action => {
        const { cardTypes } = this.state;
        const { partnerModel, fillGLAccountsPartner, action: modelAction, enableSpinner } = this.props;
        let cardType = cardTypes[action.index];
        partnerModel.CardType = cardType.code;
        partnerModel.CardTypeName = cardType.name;

        if (partnerModel.CardType === 'C' && Array.isArray(partnerModel.DeliveriesAddress) && partnerModel.DeliveriesAddress.length > 0) {
            for (let index = 0; index < partnerModel.DeliveriesAddress.length; index++) {
                let addDelivery = partnerModel.DeliveriesAddress[index];
                addDelivery.TaxCode = 'IGV';
            }
        }

        if (modelAction === 1) {
            if (partnerModel.CardType === 'C') {
                partnerModel.GroupCode = 100;
                partnerModel.GroupCodeName = 'C01 - Consumidor Final - CF';
                partnerModel.GroupNum = -1;
                partnerModel.GroupNumName = 'Contado';
            }
            if (partnerModel.CardType === 'S') {
                partnerModel.GroupCode = '';
                partnerModel.GroupCodeName = '';
                enableSpinner(true);
                let groupNumResponse = await apiClient.getGroupNum();
                enableSpinner(false);
                if (groupNumResponse?.data?.length) {
                    const { GroupNum = '', PymntGroup = '' } = groupNumResponse?.data?.find(group => group.PymntGroup?.includes('30')) ?? {};
                    partnerModel.GroupNum = GroupNum;
                    partnerModel.GroupNumName = PymntGroup;
                }
            }
        }

        $('#cardTypeModal').modal('hide');
        this.generateCardCode(partnerModel)
        this.refreshModel(partnerModel);
        fillGLAccountsPartner()
    }
    generateCardCode = (partnerModel) => {
        const { showAlert } = this.props;

        const { CardType, LicTradNum } = partnerModel;

        if (!CardType) {
            return //showAlert({ type: 'warning', message: 'Seleccione el Tipo de Socio de Negocios' });
        }
        const prefixMap = {
            'C': 'C',
            'L': 'C',
            'S': 'P'
        };
        const prefix = prefixMap[CardType];
        if (!prefix) {
            return //showAlert({ type: 'warning', message: 'Seleccione un Tipo de Socio de Negocios válido' });
        }
        const cleanLicTradNum = String(LicTradNum || '').replace(/\s+/g, '');

        const codeLen = 12;
        let numZeros = codeLen - (prefix.length + cleanLicTradNum.length);

        if (numZeros < 0) {
            numZeros = 0
        }


        partnerModel.CardCode = prefix + '0'.repeat(numZeros) + cleanLicTradNum.substring(0, 11);
    };

    openGroupCode = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getGroupCode();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        const finalData = groupCodeResponse?.data?.filter(code => code.GroupType === partnerModel.CardType)
        await this.setState({
            groupCodesModal: true,
            groupCodes: finalData,
        });

        $('#groupCodeModal').modal('show');
        $("#groupCodeModal").on("hidden.bs.modal", async () => { await this.setState({ groupCodesModal: false }); });
    };

    openGroupNum = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupNumResponse = await apiClient.getGroupNum();
        enableSpinner(false);

        if (!Array.isArray(groupNumResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupNumResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            groupNums: groupNumResponse.data,
        });

        $('#groupNumModal').modal('show');
    }

    selectGroupNum = action => {
        const { groupNums } = this.state;
        const { partnerModel } = this.props;
        let groupNum = groupNums[action.index];

        partnerModel.GroupNum = groupNum.GroupNum;
        partnerModel.GroupNumName = groupNum.PymntGroup;

        partnerModel.ChangeGroupNum = true;

        $('#groupNumModal').modal('hide');
        this.refreshModel(partnerModel);
    }

    selectGroupCode = action => {
        const { groupCodes } = this.state;
        const { partnerModel } = this.props;
        let groupCode = groupCodes[action.index];

        partnerModel.GroupCode = groupCode.GroupCode;
        partnerModel.GroupCodeName = groupCode.GroupName;

        $('#groupCodeModal').modal('hide');
        this.refreshModel(partnerModel);
    }

    openCuentaMayor = async (cuenta) => {
        const { showAlert, enableSpinner, view } = this.props;

        enableSpinner(true);
        let response = await apiClient.getCuentaMayorPartner();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accounts: response.data,
            accountMayorId: cuenta,
        });

        $('#AccountListPartnerModal').modal('show');
    }

    selectAccountList = action => {
        const { accounts, accountMayorId } = this.state;
        const { partnerModel, refreshModel } = this.props;
        let account = accounts[action.index];

        if (accountMayorId === 1) {
            partnerModel.DebPayAcct = account.FormatCode || '';
            partnerModel.DebPayAcctName = account.AcctName || '';
        }

        refreshModel(partnerModel);
        $('#AccountListPartnerModal').modal('hide');
        setTimeout(() => {
            this.setState({
                account: [],
            });
        }, 100);
    }

    openCurrency = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let currencyResponse = await apiClient.getCurrenciesPartner();
        enableSpinner(false);

        if (!Array.isArray(currencyResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (currencyResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            currencies: currencyResponse.data,
        });

        $('#currencyModal').modal('show');
    }

    selectCurrency = action => {
        const { currencies } = this.state;
        const { partnerModel } = this.props;
        let currency = currencies[action.index];

        partnerModel.Currency = currency.CurrCode;
        partnerModel.CurrencyName = currency.CurrName;
        $('#currencyModal').modal('hide');
        this.refreshModel(partnerModel);
    }

    openEmployee = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let getEmployeeResponse = await apiClient.getEmployeeList();
        enableSpinner(false);

        if (!Array.isArray(getEmployeeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getEmployeeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            employees: getEmployeeResponse.data,
        });
        $('#employeeSalesPartnerModal').modal('show');
    }

    openTerritory = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let getTerritoriesResponse = await apiClient.getTerritories();
        enableSpinner(false);

        if (!Array.isArray(getTerritoriesResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getTerritoriesResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            territories: getTerritoriesResponse.data,
        });
        $('#territoriesModal').modal('show');
    }

    selectTerritories = action => {
        const { territories } = this.state;
        const { partnerModel } = this.props;
        let territory = territories[action.index];

        partnerModel.Territory = territory.territryID || '';
        partnerModel.TerritoryName = territory.descript || '';
        this.refreshModel(partnerModel);
        $('#territoriesModal').modal('hide');
        setTimeout(() => {
            this.setState({
                territories: [],
            });
        }, 100);
    }

    selectEmployee = action => {
        const { employees } = this.state;
        const { partnerModel } = this.props;
        let employee = employees[action.index];

        partnerModel.SlpCode = employee.SlpCode || '';
        partnerModel.SlpName = employee.SlpName || '';

        this.refreshModel(partnerModel);
        $('#employeeSalesPartnerModal').modal('hide');
        setTimeout(() => {
            this.setState({
                employees: [],
            });
        }, 100);
    }

    addContactPersons = async () => {
        const { showAlert, partnerModel } = this.props;
        if (!partnerModel.ContactPersons) {
            partnerModel.ContactPersons = [];
        }
        let newContact = new ContactPersons();

        partnerModel.ContactPersons.push(newContact);
        partnerModel.contactEditIndex = partnerModel.ContactPersons.length - 1;

        await this.refreshModel(partnerModel);
    }

    deleteContactPersons = async (name) => {
        const { showAlert, partnerModel } = this.props;
        let newContact = new ContactPersons();

        let contactArray = [];
        partnerModel.ContactPersons.map(contact => {
            if (contact.Name != name) {
                contactArray.push(contact)
            }
        });

        partnerModel.ContactPersons = contactArray;
        partnerModel.contactEditIndex = null;

        if (partnerModel.CntctPrsn == name) {
            partnerModel.CntctPrsn = '';
        }

        this.refreshModel(partnerModel);
        this.setState({ contactPersons: contactArray });
    }

    openContactPersons = async () => {
        const { showAlert, partnerModel } = this.props;

        if (partnerModel.ContactPersons.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            contactPersons: partnerModel.ContactPersons,
        });

        setTimeout(() => {
            $('#contactPersonsPartnerModal').modal('show');
        }, 100)

    }

    selectContactPersons = action => {
        const { partnerModel } = this.props;
        let contact = partnerModel.ContactPersons[action.index];

        partnerModel.contactEditIndex = action.index;

        this.refreshModel(partnerModel);
        $('#contactPersonsPartnerModal').modal('hide');
    }


    addAddresses = async type => {
        const { showAlert, partnerModel } = this.props;
        let newAddress = new Addresses();

        newAddress.Country = 'PE';
        if (partnerModel.CardType === 'C') {
            newAddress.TaxCode = 'IGV';
        }

        if (type == 'invoices') {
            if (partnerModel.invoicesAddressEditIndex != null && partnerModel.InvoicesAddress.length > 0 && (partnerModel.InvoicesAddress[partnerModel.invoicesAddressEditIndex].Address === '' || partnerModel.InvoicesAddress[partnerModel.invoicesAddressEditIndex].Address === null)) {
                showAlert({ type: 'warning', message: 'Termine de agregar la dirección actual' });
            } else {
                showAlert({ type: 'info', message: 'Ingrese la dirección' });
                newAddress.TypeOfAddress = 'B';
                partnerModel.InvoicesAddress.push(newAddress);
                partnerModel.invoicesAddressEditIndex = partnerModel.InvoicesAddress.length - 1;
            }
        } else {
            if (partnerModel.deliveriesAddressEditIndex != null && partnerModel.DeliveriesAddress.length > 0 && (partnerModel.DeliveriesAddress[partnerModel.deliveriesAddressEditIndex].Address === '' || partnerModel.DeliveriesAddress[partnerModel.deliveriesAddressEditIndex].Address === null)) {
                showAlert({ type: 'warning', message: 'Termine de agregar la dirección actual' });
            } else {
                showAlert({ type: 'info', message: 'Ingrese la dirección' });
                newAddress.TypeOfAddress = 'S';
                partnerModel.DeliveriesAddress.push(newAddress);
                partnerModel.deliveriesAddressEditIndex = partnerModel.DeliveriesAddress.length - 1;
            }

        }
        this.refreshModel(partnerModel);
    }

    deleteInvoicesAddress = async (Address) => {
        const { showAlert, partnerModel } = this.props;
        let newAddress = new Addresses();

        let addressArray = [];
        partnerModel.InvoicesAddresss.map(address => {
            if (address.Address != Address) {
                addressArray.push(newAddress)
            }
        });

        partnerModel.InvoicesAddresss = addressArray;
        partnerModel.invoicesAddressEditIndex = null;

        if (partnerModel.BillToDef == Address) {
            partnerModel.BillToDef = '';
        }

        this.refreshModel(partnerModel);
    }

    openAddresses = async type => {
        const { showAlert, partnerModel } = this.props;

        let address = [];
        if (type == 'invoices') {

            if (partnerModel.InvoicesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            address = partnerModel.InvoicesAddress;
        } else {
            if (partnerModel.DeliveriesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }

            address = partnerModel.DeliveriesAddress;
        }

        this.setState({
            addresses: address,
            addressesIndexSelected: type
        });

        setTimeout(() => {
            $('#addressPartnerModal').modal('show');
        }, 100)

    }
    openBankAccount = async type => {
        const { showAlert, partnerModel } = this.props;

        setTimeout(() => {
            $('#bankAccountModal').modal('show');
        }, 100)

    }

    selectAddresses = (action) => {
        const { partnerModel } = this.props;
        const { addressesIndexSelected } = this.state;

        if (addressesIndexSelected == 'invoices') {
            partnerModel.invoicesAddressEditIndex = action.index;
        } else {
            partnerModel.deliveriesAddressEditIndex = action.index;
        }


        this.refreshModel(partnerModel);
        $('#addressPartnerModal').modal('hide');
    }

    deleteAddresses = (action) => {
        const { partnerModel } = this.props;
        const { addressesIndexSelected } = this.state;

        if (addressesIndexSelected == 'invoices') {
            partnerModel.InvoicesAddress.splice(action.index, 1);
            partnerModel.invoicesAddressEditIndex = partnerModel.InvoicesAddress.length > 0 ? 0 : null;
        } else {
            partnerModel.DeliveriesAddress.splice(action.index, 1);
            partnerModel.deliveriesAddressEditIndex = partnerModel.DeliveriesAddress.length > 0 ? 0 : null;
        }


        this.refreshModel(partnerModel);
        //$('#addressPartnerModal').modal('hide');
    }


    openListNum = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getPriceList();
        enableSpinner(false);
        if (partnerModel.GroupCode === 100) {
            showAlert({ type: 'warning', message: 'No se puede cambiar la lista de precios para Consumidor Final' });
            return;
        }

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            prices: groupCodeResponse.data,
        });

        $('#priceListPartnerModal').modal('show');
    }

    selectPriceList = action => {
        const { prices } = this.state;
        const { partnerModel } = this.props;
        let price = prices[action.index];
        partnerModel.PriceListNum = price.ListNum;
        partnerModel.PriceListNumName = price.ListName;
        $('#priceListPartnerModal').modal('hide');
        this.refreshModel(partnerModel);
    }

    openAccountBalance = async (info = null) => {
        const { partnerModel, enableSpinner, showAlert } = this.props;


        var date = new Date();
        let cardCode = partnerModel.CardCode || '';
        var firstDay = moment(new Date(date.getFullYear(), 0, 1)).format('YYYY-MM-DD');
        var lastDay = moment(new Date(date.getFullYear(), 11, 31)).format('YYYY-MM-DD');
        let data;

        if (info) {
            data = {
                CardCode: info.CardCode,
                FirstDay: info.FirstDay,
                LastDay: info.LastDay,
                DocDate: info.DocDate,
                Visualize: info.Visualize,
                VisualizeNum: info.VisualizeNum,
                OnlyUnreconciled: info.OnlyUnreconciled
            }

        } else {
            data = {
                CardCode: cardCode,
                FirstDay: firstDay,
                LastDay: lastDay,
                DocDate: true,
                Visualize: true,
                VisualizeNum: 50,
                OnlyUnreconciled: true
            }
        }


        let getAccountResponse;
        enableSpinner(true);
        getAccountResponse = await apiClient.getAccountBalance(data);
        enableSpinner(false);
        if (!Array.isArray(getAccountResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
        if (getAccountResponse.data === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        this.setState({
            CardCodeBalance: getAccountResponse.data[0],
            AccountBalan: getAccountResponse.data[1],
            AccountBalanceData: data
        });
        if (!info) {
            $('#accountBalancePartnerModal').modal('show');
        }
    }

    elementDisabled(id, action) {
        let state = document.getElementById(id);
        if (state.disabled == false) {
            action()
        }
    }

    onChangeValueConsolidacion = (event) => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.VatStatus = event.nativeEvent.target.value;
        refreshModel(partnerModel);

    }

    onChangeValueConsolidacion2 = (event) => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.FatherType = event.nativeEvent.target.value;
        refreshModel(partnerModel);

    }

    onChangeRetencion = () => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.WTLiable = !partnerModel.WTLiable;
        refreshModel(partnerModel);
    }

    changeBPField = (field, value, maxLength = null) => {
        const { partnerModel, refreshModel } = this.props;
        if (maxLength !== null) {
            if (value.length > maxLength) return;
        }
        partnerModel[field] = value;
        refreshModel(partnerModel);
    }

    validateDateField = (field, name, value) => {
        const { partnerModel, refreshModel, showAlert } = this.props;
        if (!moment(value).isValid()) {
            showAlert({ type: "warning", message: `Ingrese un valor valido para el campo ${name}` });
            value = "";
        }

        partnerModel[field] = value;
        refreshModel(partnerModel);
    }

    openTaxWithholdingModal = async (type = null) => {
        if (!type) return;
        const { showAlert, enableSpinner, partnerModel } = this.props;

        enableSpinner(true);
        const responseAPI = await apiClient.getTaxWithholdingCatalog(type);
        enableSpinner(false);

        if (responseAPI.status === SERVICE_RESPONSE.SUCCESS) {
            if (Array.isArray(responseAPI.data) && responseAPI.data?.length) {
                const data = responseAPI.data;
                let selectionArray = Array.isArray(partnerModel.BPWithholdingTaxCollection) ? partnerModel.BPWithholdingTaxCollection : []; // Is valid Array
                selectionArray = selectionArray.filter(({ WTCode }) => data.some(({ Code }) => WTCode === Code)); // Filter by Active Taxes found

                const taxesModalInfo = {
                    title: `Código RI ${type === "V" ? " IVA" : "Impuesto Sobre la Renta"}`,
                    data,
                    action: (newArray) => this.seleectWTCodes(type, newArray),
                    selection: selectionArray.map(({ WTCode }) => WTCode), // Format Object Array -> String Array
                };

                await this.setState({ showTaxesModal: true, taxesModalInfo });
                $("#TaxesModal").modal("show");
                $("#TaxesModal").on("hide.bs.modal", () => this.setState({ showTaxesModal: false, taxesModalInfo: {} }));
            } else {
                showAlert({ type: "info", message: "No hay información para mostrar" });
            }
        } else {
            showAlert({ type: "warning", message: responseAPI.message || "Ha ocurridó un error con el servidor, intente más tarde" });
        }
    }

    seleectWTCodes = (type, newArray) => {
        const { partnerModel, refreshModel } = this.props;
        if (!Array.isArray(newArray)) { newArray = []; }
        newArray = newArray.map((WTCode) => ({ WTCode, Type: type })); // Format String Array -> Object Array
        let oldArray = Array.isArray(partnerModel.BPWithholdingTaxCollection) ? partnerModel.BPWithholdingTaxCollection : [];
        oldArray = oldArray.filter(({ Type }) => Type !== type); // Get other types of taxes

        partnerModel.BPWithholdingTaxCollection = oldArray.concat(newArray); // Join other types with news
        refreshModel(partnerModel);
    }

    hideOrDisableFields(field, editMode) {
        let element = document.getElementById(field.id);
        // const { editMode} = this.state;
        if (element !== null) {
            if (field.show === false) {
                element.classList.add('hidden');
            } else {
                element.classList.remove('hidden');
            }
            // console.log('job editModeeditModeeditMode', editMode)
            if (editMode == false || field.edit === false) {
                $("#" + field.id).find("input, button, submit, textarea, select").attr("disabled", "disabled");
                $("#" + field.id).find("a").addClass("disablehyper").click(function (e) { e.preventDefault(); });
                $("#" + field.id).find("input, button, submit, textarea, select").addClass("disable");
            } else {
                $("#" + field.id).find("input, button, submit, textarea, select").removeAttr("disabled");
                $("#" + field.id).find("a").removeClass("disablehyper").unbind("click");
                $("#" + field.id).find("input, button, submit, textarea, select").removeClass("disable");
            }
        }
    }

    checkConfigFields(userConfig, editMode = false) {
        let config = JSON.parse(localStorage.getItem(userConfig)) || null;
        for (const key in config) {
            this.hideOrDisableFields(config[key], editMode)
        }
    }

    renderBussinesFooter = () => {
        return (
            <div className="row col-sm col">

                <div className="col-12 col-md-6">
                    {/*Teléfono1*/}
                    <div className="form-group row" id="div1">
                        <label htmlFor="txtContactPerson"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Condición de
                            Pago: </label>
                        <div className="col-md-6 col-sm-12">
                            <select id="inputState" className="form-control btn-outline-secondary"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                <option selected>...</option>
                                <option>...</option>
                            </select>
                        </div>

                    </div>
                    {/*Teléfono2*/}
                    <div className="form-group row" id="div1">
                        <label htmlFor="txtContactPerson"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Método de Pago</label>
                        <div className="col-md-6 col-sm-12">
                            <select id="inputState" className="form-control btn-outline-secondary"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                <option selected>...</option>
                                <option>...</option>
                            </select>
                        </div>

                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*Moneda Local*/}
                    <div className="form-group row" id="div1">
                        <label htmlFor="txtContactPerson"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Lista de Precios: </label>
                        <div className="col-md-6 col-sm-12">
                            <select id="inputState" className="form-control btn-outline-secondary"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                <option selected>...</option>
                                <option>...</option>
                            </select>
                        </div>
                    </div>
                    {/*RFC DE SOCIO DE NEGOCIOS*/}
                    <div className="form-group row " id="div1">
                        <label htmlFor="txtAlmacen" className="col-md-4 col-sm-12 col-form-label font-weight-bold">Límite
                            de Crédito:</label>
                        <div className="col-md-6 col-sm-12">
                            <input
                                className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                id="txtRFC" />
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    openUserFields = () => {
        $('#userFieldsPartnerModal').modal('show');
    }

    validateRUC = async () => {
        const { showAlert, enableSpinner, partnerModel, refreshModel } = this.props;
        const autoSeleccionado = this.autoSelectPersonType(partnerModel.LicTradNum);

        if (!autoSeleccionado && !partnerModel.CardType) {
            return showAlert({ type: "warning", message: "Seleccione un tipo de persona para continuar" });
        }
        if (!partnerModel.LicTradNum || ((partnerModel.LicTradNum?.length != 11) && (partnerModel.LicTradNum?.length != 8))) {
            return showAlert({ type: "warning", message: "Ingrese un RUC/DNI valido para continuar" });
        }
        const data = {
            RUC: partnerModel.LicTradNum,
            CardType: partnerModel.CardType,
            CardCode: partnerModel.CardCode,
        };


        enableSpinner(true);
        let apiResponse = await apiClient.validateRUC(data);
        enableSpinner(false);

        if (!apiResponse.status) {
            return showAlert({ type: 'error', message: apiResponse?.message || 'Ocurrió un error al consultar la Información' });
        }
        showAlert({ type: 'success', message: apiResponse.message });
        const businessData = apiResponse.data;
        partnerModel.CardName = businessData.CardName;
        this.clearAddress()
        this.fillDNIData({})
        await this.fillRUCData({})
        this.fillPadron({})
        if (partnerModel.LicTradNum.length === 11) {
            await this.fillRUCData(businessData)
            enableSpinner(true);
            let apiResponse2 = await apiClient.validatePadron(data);
            enableSpinner(false);
            if (apiResponse2.status === SERVICE_RESPONSE.SUCCESS) {
                this.fillPadron(apiResponse2?.data ?? {})
            } else {
                showAlert({ type: 'success', message: 'Error al consultar padrón' });
            }

        } else if (partnerModel.LicTradNum.length === 8) {
            this.fillDNIData(businessData)
        }
        refreshModel(partnerModel);
    }

    autoSelectPersonType = (ruc) => {
        if (!ruc) return false;

        let tipoPersona = null;
        const prefix = ruc.substring(0, 2);

        if (ruc.length === 11) {
            if (prefix === '20') {
                tipoPersona = 'TPJ';
            } else if (prefix === '10' || prefix === '15') {
                tipoPersona = 'TPN';
            }
        } else if (ruc.length === 8) {
            tipoPersona = 'TPN';
        }

        if (tipoPersona) {
            const { partnerModel, refreshModel } = this.props;
            const fieldIndex = json.userFieldsPartners.findIndex(
                field => field.fieldId === 15 && field.enabled
            );

            if (fieldIndex !== -1) {
                const field = json.userFieldsPartners[fieldIndex];
                const key = `userFields${field.IdValue + 1}`;
                partnerModel.userFields[key] = tipoPersona;
            }
            refreshModel(partnerModel);
            return true;
        }
        return false;
    };

    clearAddress() {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.deliveriesAddressEditIndex = null;
        partnerModel.invoicesAddressEditIndex = null;
        partnerModel.DeliveriesAddress = []
        partnerModel.InvoicesAddress = []
        refreshModel(partnerModel);
    }

    fillPadron(incomingData) {
        const { partnerModel, refreshModel, userFieldsPartner } = this.props;
        let copyFields = json.userFieldsPartners;
        copyFields.map((item, index) => {
            userFieldsPartner.map(userfieldItem => {

                if (item.fieldId === userfieldItem.header.FieldID && item.enabled) {
                    let key = `userFields${index + 1}`
                    switch (userfieldItem.header.AliasID) {
                        case 'STR_AR':
                            partnerModel.userFields[key] = incomingData?.Agente_Recepcion ?? ''
                            break;
                        case 'STR_AP':
                            partnerModel.userFields[key] = incomingData?.Agente_Percepcion ?? ''
                            break;
                        case 'STR_BC':
                            partnerModel.userFields[key] = incomingData?.Buen_Contribuyente ?? ''
                            break;
                        case 'LLG_NRUS':
                            partnerModel.userFields[key] = incomingData?.Nuevo_Rus ?? ''
                            break;
                        default:
                            break;
                    }
                }
            });
        });
        refreshModel(partnerModel);
    }
    fillRUCData = async (incomingData) => {
        const { partnerModel, refreshModel, userFieldsPartner, enableSpinner } = this.props;
        partnerModel.CardName = incomingData?.CardName?.toUpperCase() ?? ''
        let copyFields = json.userFieldsPartners;
        copyFields.map((item, index) => {
            userFieldsPartner.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID && item.enabled) {
                    let key = `userFields${index + 1}`
                    switch (userfieldItem.header.AliasID) {
                        case 'BPP_BPTD':
                            partnerModel.userFields[key] = incomingData?.RUC ? 6 : ''
                            break;
                        case 'STR_EST_CNTR':
                            partnerModel.userFields[key] = incomingData?.Status ?? ''
                            break;
                        case 'STR_NH':
                            partnerModel.userFields[key] = incomingData?.Conditions ?? ''
                            break;


                        default:
                            break;
                    }
                }
            });
        });
        if (incomingData?.CardName ?? null != null) {//VALIDATE CITY
            enableSpinner(true);
            let groupCodeResponse = await apiClient.getState();
            enableSpinner(false);
            groupCodeResponse = groupCodeResponse?.data ?? []
            for (let index = 0; index < incomingData.InvoicesAddress.length; index++) {
                const address = incomingData.InvoicesAddress[index];
                if ((address?.Country ?? null) != null && (address?.Country ?? '') != '') {
                    const findState = groupCodeResponse.find(addr => {
                        const matchName = (addr?.Name ?? '')?.toUpperCase() === (address?.State ?? '')?.toUpperCase();
                        const matchCode = (addr?.Code ?? '')?.toUpperCase() === (address?.State ?? '')?.toUpperCase();
                        return matchName || matchCode;
                    });
                    if (findState) {
                        address.State = findState?.Code ?? null;
                        address.County = findState?.Name ?? null;
                    } else {
                        address.State = null;
                    }
                } else {
                    address.State = null
                }
            }
            for (let index = 0; index < incomingData.DeliveriesAddress.length; index++) {
                const address = incomingData.DeliveriesAddress[index];
                if ((address?.Country ?? null) != null && (address?.Country ?? '') != '') {
                    const findState = groupCodeResponse.find(addr =>
                    (((addr?.Name ?? '')?.toUpperCase() === (address?.State ?? '')?.toUpperCase()) ||
                        ((addr?.Code ?? '')?.toUpperCase() === (address?.State ?? '')?.toUpperCase()))
                    );
                    if (findState) {
                        address.State = findState?.Code ?? null;
                        address.County = findState?.Name ?? null;
                    } else {
                        address.State = null;
                    }
                } else {
                    address.State = null
                }
            }
        }

        // if (partnerModel?.LicTradNum?.substring(0, 2) == '20' || partnerModel?.LicTradNum?.substring(0, 2) == '10') {
        // Buscar direciones de facturación y entrega
        if (Array.isArray(partnerModel.InvoicesAddress)) {
            let billAddress = new Addresses();
            billAddress.TypeOfAddress = 'B';

            let findAddress = partnerModel.InvoicesAddress.findIndex(({ Address }) => Address === "FISCAL");
            if (findAddress !== -1) { billAddress = partnerModel.InvoicesAddress[findAddress]; }
            const invoiceAddress = incomingData?.InvoicesAddress?.[0] ?? null;
            if (invoiceAddress) {
                billAddress.Street = (invoiceAddress?.Street || "");
                billAddress.Block = invoiceAddress?.Block || "";
                billAddress.City = invoiceAddress?.City || "";
                billAddress.ZipCode = invoiceAddress?.ZipCode || "";
                billAddress.County = invoiceAddress?.County || "";
                billAddress.Country = invoiceAddress?.Country || "PE";
                billAddress.State = invoiceAddress?.State || "";

                // billAddress.StreetNo = `${(invoiceAddress?.StreetNumber ?? '') != '' ? `NRO. ${invoiceAddress?.StreetNumber}` : ''} ${(invoiceAddress?.Interior ?? '') != '' ? `INT. ${invoiceAddress?.Interior}` : ''}`;

                if (findAddress === -1 && (invoiceAddress?.Address ?? null) != null) {
                    billAddress.Address = invoiceAddress?.Address ?? "FISCAL";
                    partnerModel.InvoicesAddress.push(billAddress);
                    partnerModel.invoicesAddressEditIndex = partnerModel.InvoicesAddress.length - 1;
                } else if (findAddress !== -1) {
                    partnerModel.invoicesAddressEditIndex = findAddress;
                }
            }
        }

        //DELIVERIES
        if (Array.isArray(partnerModel.DeliveriesAddress)) {
            if (Array.isArray(incomingData?.DeliveriesAddress)) {
            for (let index = 0; index < incomingData?.DeliveriesAddress?.length; index++) {
                const deliveryAddress = incomingData?.DeliveriesAddress?.[index];
                let billAddress = new Addresses();
                billAddress.TypeOfAddress = 'S';

                let findAddress = partnerModel.DeliveriesAddress.findIndex(({ Address }) => Address === (deliveryAddress?.Address ?? -1));
                if (findAddress !== -1) { billAddress = partnerModel.DeliveriesAddress[findAddress]; }
                billAddress.Street = deliveryAddress?.Street || "";
                billAddress.Block = deliveryAddress?.Block || "";
                billAddress.City = deliveryAddress?.City || "";
                billAddress.ZipCode = deliveryAddress?.ZipCode || "";
                billAddress.County = deliveryAddress?.County || "";
                billAddress.Country = deliveryAddress?.Country || "PE";
                billAddress.State = deliveryAddress?.State || "";
                // Precargar indicador de impuesto cuando se llena el ruc y es de tipo Cliente
                billAddress.TaxCode = partnerModel.CardType === 'C' ? 'IGV' : '';

                billAddress.U_FMB_GPSLon = deliveryAddress?.Lon || "";
                billAddress.U_FMB_GPSLat = deliveryAddress?.Lat || "";

                if (findAddress === -1) {
                    billAddress.Address = deliveryAddress?.Address || "";
                    partnerModel.DeliveriesAddress.push(billAddress);
                    partnerModel.deliveriesAddressEditIndex = partnerModel.DeliveriesAddress.length - 1;
                } else {
                    partnerModel.deliveriesAddressEditIndex = findAddress;
                }

            }

        }
    }

    const invoicesForBatch = Array.isArray(partnerModel.InvoicesAddress) ? partnerModel.InvoicesAddress : [];
    const deliveriesForBatch = Array.isArray(partnerModel.DeliveriesAddress) ? partnerModel.DeliveriesAddress : [];

    if (invoicesForBatch.length > 0 || deliveriesForBatch.length > 0) {
        const allAddresses = [...invoicesForBatch, ...deliveriesForBatch].filter(a => a?.State);

        if (allAddresses.length > 0) {
            const country = allAddresses[0].Country || "PE";
            const uniqueStates = [...new Set(allAddresses.map(a => a.State))];

            let provinciasByState = {};
            try {
                enableSpinner(true);
                const provinciasResponse = await apiClient.getProvincias({
                    code: uniqueStates,
                    country
                });
                enableSpinner(false);

                const provinciasData = Array.isArray(provinciasResponse?.data) ? provinciasResponse.data : [];
                uniqueStates.forEach(state => {
                    provinciasByState[state] = provinciasData.filter(p => p.StateCode === state);
                });
            } catch (error) {
                enableSpinner(false);
                uniqueStates.forEach(state => { provinciasByState[state] = []; });
            }

            invoicesForBatch.forEach(invoiceAdd => {
                if (invoiceAdd?.State) {
                    invoiceAdd.provinciasInvoices = provinciasByState[invoiceAdd.State] || [];
                }
            });
            deliveriesForBatch.forEach(deliveryAddress => {
                if (deliveryAddress?.State) {
                    deliveryAddress.provinciasDeliveries = provinciasByState[deliveryAddress.State] || [];
                }
            });

            const uniqueStateProvinciaPairs = [...new Set(
                allAddresses.filter(a => a?.County).map(a => `${a.State}|${a.County}`)
            )];

            if (uniqueStateProvinciaPairs.length > 0) {
                const statesWithCounty = [...new Set(uniqueStateProvinciaPairs.map(pair => pair.split('|')[0]))];
                const provinciasList = [...new Set(uniqueStateProvinciaPairs.map(pair => pair.split('|')[1]))];

                let distritosByStateProvincia = {};
                try {
                    enableSpinner(true);
                    const distritosResponse = await apiClient.getDistritos({
                        code: statesWithCounty,
                        country,
                        provincia: provinciasList
                    });
                    enableSpinner(false);

                    const distritosData = Array.isArray(distritosResponse?.data) ? distritosResponse.data : [];
                    uniqueStateProvinciaPairs.forEach(pair => {
                        const [state, provincia] = pair.split('|');
                        distritosByStateProvincia[pair] = distritosData.filter(
                            d => d.StateCode === state && d.City === provincia
                        );
                    });
                } catch (error) {
                    enableSpinner(false);
                    uniqueStateProvinciaPairs.forEach(pair => { distritosByStateProvincia[pair] = []; });
                }

                invoicesForBatch.forEach(invoiceAdd => {
                    if (invoiceAdd?.State && invoiceAdd?.County) {
                        invoiceAdd.distritosInvoices = distritosByStateProvincia[`${invoiceAdd.State}|${invoiceAdd.County}`] || [];
                    }
                });
                deliveriesForBatch.forEach(deliveryAddress => {
                    if (deliveryAddress?.State && deliveryAddress?.County) {
                        deliveryAddress.distritosDeliveries = distritosByStateProvincia[`${deliveryAddress.State}|${deliveryAddress.County}`] || [];
                    }
                });
            }
        }
    }

        refreshModel(partnerModel);

        if (incomingData?.ISDNI ?? false) {
            this.fillDNIData(incomingData)
        }
    }
    
    fillDNIData(incomingData) {
        const { partnerModel, refreshModel, userFieldsPartner } = this.props;
        let copyFields = json.userFieldsPartners;
        copyFields.map((item, index) => {
            userFieldsPartner.map(userfieldItem => {
                if (item.fieldId === userfieldItem.header.FieldID && item.enabled) {
                    let key = `userFields${index + 1}`
                    switch (userfieldItem.header.AliasID) {
                        case 'BPP_BPAM':
                            partnerModel.userFields[key] = incomingData?.apellidoMaterno?.toUpperCase() ?? ''
                            break;
                        case 'BPP_BPAP':
                            partnerModel.userFields[key] = incomingData?.apellidoPaterno?.toUpperCase() ?? ''
                            break;
                        case 'BPP_BPNO':
                            partnerModel.userFields[key] = incomingData?.nombres?.toUpperCase() ?? ''
                            break;
                        case 'BPP_BPTD':
                            partnerModel.userFields[key] = incomingData?.dni ? 1 : ''
                            break;

                        default:
                            break;
                    }
                }
            });
        });
        if (!(incomingData?.ISDNI ?? false)) {
            partnerModel.CardName = incomingData?.nombreCompleto?.toUpperCase() ?? ''
        }

        refreshModel(partnerModel);
    }
    setUserFieldValue = (userFields, index, header) => {
        const { view } = this.props;
        let key = `userFields${index + 1}`
        let value = header[key]
        switch (index) {
            case 20:
                if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
                    value !== '' ? userFields[key] = this.validateNull(value) : userFields[key] = '99'
                } else {
                    userFields[key] = this.validateNull(value);
                }
                break;
            case 22:
                if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote' && view !== "adminUsersMVentas") {
                    value !== '' ? userFields[key] = this.validateNull(value) : userFields[key] = '99'
                } else {
                    userFields[key] = this.validateNull(value);
                }
                break;
            case 24:
                if (view !== 'inventoryRevaluation' && view !== 'bussinesPartner' && view !== 'administratorUsers' && view !== 'figuresTransport' && view !== 'transports' && view !== 'consignmentNote') {
                    value !== '' ? userFields[key] = this.validateNull(value) : userFields[key] = '99'
                } else {
                    userFields[key] = this.validateNull(value);
                }
                break;
            default:
                userFields[key] = this.validateNull(value);
                break;

        }
        return userFields;
    };
    validateNull = (value) => {
        if (value === 0) {
            return value;
        }
        if (!value) {
            return "";
        }

        return (value || '').toString().trim();
    };

    uploadAttachments = async (target) => {
        const { showAlert, refreshModel, partnerModel } = this.props;
        const validExtensions = ['pdf']; // Extensiones válidas
        let attachments = Array.isArray(partnerModel.Attachments) ? JSON.parse(JSON.stringify(partnerModel.Attachments)) : [];
        try {
            if (!target?.files?.length) { return showAlert({ type: "warning", message: "No se seleccionó ningún archivo" }); }
            for (const file of target.files) {
                const filename = file.name.split('.').shift();
                const fileExtension = file.name.split('.').pop().toLowerCase();
                if (!validExtensions.includes(fileExtension)) { return showAlert({ type: "error", message: `Error al cargar el archivo (${file.name}): Extensión no valida` }); } // Validar extensión del archivo
                file.FileExt = fileExtension;
                file.FileName = filename;
                attachments.push(file);
            }
        } catch (error) {
            return showAlert({ type: "error", message: "Ocurrió un error al cargar el archivo" });
        }
        partnerModel.Attachments = attachments;
        refreshModel(partnerModel);
    }

    removeAttachments = async (index = -1) => {
        const { refreshModel, partnerModel } = this.props;
        let attachments = Array.isArray(partnerModel.Attachments) ? JSON.parse(JSON.stringify(partnerModel.Attachments)) : [];
        attachments.splice(index, 1);
        partnerModel.Attachments = attachments;
        refreshModel(partnerModel);
    }

    renderSelector = () => {
        return (
            <div className="row">
                <div className="col">
                    <div className="float-right">
                        <label className="font-weight-bold mr-2">
                            <span className="d-none d-xl-inline">Campos de Usuario</span>
                            <span className="d-inline d-xl-none">Campos Usuario</span>
                        </label>
                        <button
                            type="button"
                            className="btn btn-outline-warning border-0 mb-2"
                            onClick={this.openUserFields}>
                            <i className="fa fa-list" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderEditButton = () => {
        const { action, writeAccess } = this.props;
        const { editMode } = this.state;

        if (action === 2 && !editMode && writeAccess) {
            return (
                <div className="row">
                    <div className="col">
                        <button
                            type="button"
                            className="btn btn-outline-dark border-0 mb-2 btn-editar"
                            onClick={this.editMode} >
                            <i className="fas fa-edit mr-2" /> Editar
                        </button>
                    </div>
                </div>
            );
        }
    }

    returnValueItem = (index) => {
        const { partnerModel } = this.props;
        const fields = partnerModel?.userFields;

        if (!fields) return "";

        const key = `userFields${index + 1}`;
        return fields[key] ?? "";
    };

    changeUserFieldsItemsDocument = async (event, IdValue, index) => {
        const { partnerModel, refreshModel } = this.props;
        const value = event.nativeEvent.target.value;

        const key = `userFields${IdValue + 1}`;
        partnerModel.userFields[key] = value;
        refreshModel(partnerModel);
    };

    renderBussinesHeader = () => {
        const { partnerModel, action } = this.props;
        const { editMode } = this.state;

        let titleDNotesBal = '';
        let titleOrdersBal = '';

        if (partnerModel?.CardType === 'C') {
            titleDNotesBal = 'Entregas:';
            titleOrdersBal = 'P. clientes:';
        } else if (partnerModel?.CardType === 'S') {
            titleDNotesBal = 'P. E. Mercancías:';
            titleOrdersBal = 'Pedidos:';
        } else if (partnerModel?.CardType === 'L') {
            titleDNotesBal = 'P. E. Mercancías:';
            titleOrdersBal = 'P. clientes:';
        }

        return (
            <div className="row">
                {/*PRIMER COLUMNA SOCIOS DE NEGOCIO*/}

                <div className="col-12 col-md-6">
                    {/*CÓDIGO DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Código </span>
                        </div>
                        <input
                            className="form-control"
                            id="txtCardCode"
                            disabled={true}//{action === 2}
                            onChange={this.changeBusinessPartnerCardCode}
                            value={partnerModel?.CardCode || ""}
                            onKeydown={(ev) => { if (ev.key === 'Enter' && partnerModel.CardCode.length >= 2) { this.getBusinessPartnerCode(); } }} />

                        {/* {(action === 1) && partnerModel?.CardCode.length >= 2 && (
                            <button
                                type="button"
                                className="btn btn-outline-warning"
                                onClick={this.getBusinessPartnerCode} >
                                <i className="fa fa-list" />
                            </button>
                        )} */}

                        {((action === 2) && partnerModel?.CardCode !== '') && (
                            <button
                                type="button"
                                className="btn btn-outline-warning"
                                onClick={() => this.openAccountBalance()} >
                                <i className="fas fa-info-circle" />
                            </button>)}
                    </div>

                    {/*Typo DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Tipo </span>
                        </div>
                        <input
                            className="form-control"
                            disabled
                            value={partnerModel?.CardTypeName || ""} />
                        {!(action === 2 && !editMode) && (
                            <button
                                type="button"
                                className="btn btn-outline-warning"
                                onClick={this.openCardType} >
                                <i className="fa fa-list" />
                            </button>
                        )}
                    </div>
                    {/*NOMBRE DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                Nombre
                                {/* <ToolTip tips={ToolTips.GeneralTips.RenameBP} position={'up'} /> */}
                            </span>
                        </div>
                        <input
                            className="form-control"
                            id="txtCardName"
                            disabled={action === 2 && !editMode}
                            onChange={this.changeBusinessPartnerCardName}
                            value={partnerModel?.U_FMB_AUX_CARDNAME || partnerModel?.CardName || ""}
                        />
                    </div>

                    {/*GRUPO DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Grupo </span>
                        </div>
                        <input
                            className="form-control"
                            readOnly
                            disabled
                            value={partnerModel?.GroupCodeName || ""} />
                        {((action === 2 && editMode) || (action === 1 && partnerModel?.CardType === 'S')) && (
                            <button
                                type="button"
                                className="btn btn-outline-warning"
                                onClick={this.openGroupCode} >
                                <i className="fa fa-list" />
                            </button>
                        )}
                    </div>

                    {/*MONEDA DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Moneda </span>
                        </div>
                        <input
                            className="form-control"
                            readOnly
                            disabled
                            value={partnerModel?.CurrencyName || ""} />
                        {!(action === 2 && !editMode) && (
                            <button
                                type="button"
                                className="btn btn-outline-warning"
                                onClick={this.openCurrency} >
                                <i className="fa fa-list" />
                            </button>
                        )}
                    </div>

                    {/*RUC*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">RUC</span>
                        </div>
                        <input
                            id="rfcB"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            onChange={this.changeBusinessPartnerLicTradNum}
                            value={partnerModel.LicTradNum ? partnerModel.LicTradNum : ""} />
                        {!(action === 2 && !editMode) && (
                            <button
                                type="button"
                                className="btn btn-outline-warning"
                                onClick={this.validateRUC} >
                                <i className="fa fa-search" />
                            </button>
                        )}
                    </div>
                    <div className="form-group formulario__grupo" id="grupo__rfcB">
                        <p className="form__input-error" style={{ marginTop: "-14px" }}>{"Formato valido: (XAXX010101000)"}</p>
                        <p className="form__input-void" style={{ marginTop: "-14px" }}> RUT no puede ir vacio </p>
                    </div>
                </div>

                {/*SEGUNDA COLUMNA SOCIOS DE NEGOCIO*/}

                <div className="col-12 col-md-6">
                    {(action == 2 && (partnerModel.CardType == 'C' || partnerModel.CardType == 'S')) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    <span className="d-none d-xl-inline">Saldo de cuenta</span>
                                    <span className="d-inline d-xl-none">Saldo</span>
                                </span>
                            </div>
                            <input
                                className="form-control text-right"
                                disabled
                                readOnly
                                value={CURRENCY + formatNumber.new(partnerModel.Balance)} />
                        </div>}
                    {/*pedidos deetrada de mercancia*/}
                    {(action == 2 && (partnerModel.CardType == 'C' || partnerModel.CardType == 'S')) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">{titleDNotesBal}</span>
                            </div>
                            <input
                                className="form-control text-right"
                                disabled
                                readOnly
                                value={CURRENCY + formatNumber.new(partnerModel.DNotesBal)} />
                        </div>}
                    {/*Saldo de Cuenta*/}
                    {action == 2 &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">{titleOrdersBal}</span>
                            </div>
                            <input
                                className="form-control text-right"
                                disabled
                                readOnly
                                value={CURRENCY + formatNumber.new(partnerModel.OrdersBal)} />
                        </div>}
                    {json.userFieldsPartners.map((field, index) => {
                        if (field.enabled && field.name) {
                            if (field.fieldId === 14 || field.fieldId === 15) {
                                return (
                                    <div className="input-group mb-3" key={index}>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">{field.name || ''}</span>
                                        </div>
                                        {(
                                            Number(field.fieldType) === 1 ?
                                                <input
                                                    className="form-control"
                                                    type={(field.fieldId === 15 || field.fieldId === 76 || field.fieldId === 80 || field.fieldId === 147) ? "date" : "text"}
                                                    id={'inputUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    value={this.returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}
                                                /> :
                                                <select
                                                    className="form-control"
                                                    id={'selectUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    value={this.returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}
                                                >
                                                    {field.options.map((option) => {
                                                        if (option.FldValue != null) {
                                                            return (
                                                                <option key={option.FldValue} value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }

                                                    })}
                                                </select>
                                        )}
                                    </div>
                                );
                            }
                        } else {
                            return (<></>)
                        }
                    })}
                </div>


            </div>
        )
    }
    changeAddressValue = (value, key, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex][key] = value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex][key] = value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);

    }

    changeBlurAddressValue = (value, key, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;

        if (type === 'invoices') {
            if (invoicesAddressEditIndex != null) {
                if (['U_FMB_GPSLat', 'U_FMB_GPSLon']?.includes(key)) {
                    partnerModel.InvoicesAddress[invoicesAddressEditIndex][key] = this.sanitizeInteger(value);
                } else {
                    partnerModel.InvoicesAddress[invoicesAddressEditIndex][key] = value;
                }
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                if (['U_FMB_GPSLat', 'U_FMB_GPSLon']?.includes(key)) {
                    partnerModel.DeliveriesAddress[deliveriesAddressEditIndex][key] = this.sanitizeInteger(value);
                } else {
                    partnerModel.DeliveriesAddress[deliveriesAddressEditIndex][key] = value;
                }
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    }

    sanitizeInteger = (val) => {
        if (!val) return '';

        let cleaned = String(val);
        cleaned = cleaned?.replace(/[^0-9.-]/g, ''); // Quitar todo lo que no sea número, '-' o '.'
        cleaned = cleaned?.replace(/(?!^)-/g, ''); // Permitir solo un '-' y solo al inicio
        const parts = cleaned?.split('.'); // Permitir solo un '.'
        if (parts?.length > 2) {
            cleaned = parts[0] + '.' + parts.slice(1).join('');
        }

        if (/^-\.\d+/.test(cleaned)) {
            cleaned = cleaned?.replace(/^-\./, '-0.');
        } else if (/^\.\d+/.test(cleaned)) {
            cleaned = cleaned?.replace(/^\./, '0.');
        }

        if (
            cleaned === '-' ||
            cleaned === '.' ||
            cleaned === '-.' ||
            cleaned === '.-' ||
            Number(cleaned) === 0
        ) {
            return '';
        }
        return cleaned;
    };

    openMap = async (currSelectionAddress, typeSelectionAddress) => {
        await this.setState({ showMap: true, currSelectionAddress, typeSelectionAddress });

    }

    validateOSIN = async (search, type) => {
        const { enableSpinner, showAlert } = this.props;
        const data = {
            search,
            type
        }
        enableSpinner(true);
        const responseApi = await apiClient.validateOSIN(data);
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: 'Validación exitosa' });
            const resp = responseApi?.data ?? {}
            this.changeAddressValue(resp?.U_FMB_FICHA_OSIN ?? '', 'U_FMB_FICHA_OSIN', type)
            this.changeAddressValue(resp?.U_FMB_OSIN_CAPACIDAD ?? '', 'U_FMB_OSIN_CAPACIDAD', type)
            this.changeAddressValue(resp?.U_FMB_OSIN_STATUS ?? '', 'U_FMB_OSIN_STATUS', type)
            this.changeAddressValue(resp?.U_FMB_OSIN_TIPAGENT ?? '', 'U_FMB_OSIN_TIPAGENT', type)
        } else {
            showAlert({ type: 'error', message: 'Servicio no disponible' });
        }
    }

    handleDocumentChange = (field, value) => {
        const { partnerModel, refreshModel } = this.props;

        try {
            if (!(field in partnerModel)) {
                return;
            }
            if (value && !(value instanceof File) && typeof value !== 'string') {
                return;
            }

            const newPartnerModel = { ...partnerModel, [field]: value };
            refreshModel(newPartnerModel);
        } catch (error) {
            console.error('Error al actualizar documento:', error);
        }
    }

    removeDocument = (field, fileName) => {
        const { partnerModel, refreshModel } = this.props;
        const newPartnerModel = { ...partnerModel, [field]: '' };
        refreshModel(newPartnerModel);
    }

    getUDFAttachments = (partnerModel) => {
        const attachments = [];

        for (let i = 1; i <= 6; i++) {
            const fieldName = `U_RS_Doc${i}`;
            const fieldValue = partnerModel[fieldName];

            if (fieldValue && typeof fieldValue === 'string' && fieldValue.trim() !== '') {
                attachments.push({
                    AbsEntry: fieldValue,
                    FileName: fieldValue.split('\\').pop() || `Documento${i}`,
                    FileExt: 'pdf',
                    Date: new Date().toISOString(),
                    FilePath: fieldValue,
                    IsUDF: true,
                    UDFField: fieldName
                });
            }
        }

        return attachments;
    }


    downloadUDFAttachment = async (udfAttachment) => {
        const { enableSpinner, showAlert } = this.props;

        try {
            enableSpinner(true);
            const response = await apiClient.downloadAttachmentFile({
                AbsEntry: udfAttachment.filePath,
                FileName: udfAttachment.fileName
            });

            enableSpinner(false);
            if (response.status === SERVICE_RESPONSE.SUCCESS) {
                let getFieldName = response.headers.get('content-disposition');
                if (getFieldName !== null) {
                    let start = getFieldName.indexOf("filename=") + 10;
                    let end = getFieldName.indexOf('"', start);
                    try {
                        response.blob().then(blob => saveAs(blob, getFieldName.slice(start, end)));
                        showAlert({ type: 'success', message: 'Descarga iniciada' });
                    } catch (e) {
                        showAlert({ type: 'error', message: `Error al descargar el archivo`, timeOut: 5000 });
                    }
                } else {
                    response.blob().then(blob => saveAs(blob, udfAttachment.fileName));
                    showAlert({ type: 'success', message: 'Descarga iniciada' });
                }
            } else {
                showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
            }

        } catch (error) {
            enableSpinner(false);
            showAlert({ type: "error", message: "Error al descargar el archivo: " + error.message });
        }
    }

    loadExistingDocuments = () => {
        const { partnerModel } = this.props;
        const uploadedDocs = {};

        for (let i = 1; i <= 6; i++) {
            const fieldName = `U_RS_Doc${i}`;
            const docValue = partnerModel[fieldName];

            if (docValue && docValue !== '' && docValue !== 'null' && docValue !== 'undefined') {
                uploadedDocs[fieldName] = {
                    fileName: typeof docValue === 'string' ? docValue.split('\\').pop() : docValue.name,
                    filePath: docValue,
                    uploaded: true
                };
            }
        }

        this.setState({ uploadedDocuments: uploadedDocs });
    }
    renderBussinesBody = () => {
        const { partnerModel, action, downloadAttachmentsFiles } = this.props;
        const { editMode, glAccountsSelect } = this.state;
        const { ContactPersons, DeliveriesAddress, InvoicesAddress, contactEditIndex, deliveriesAddressEditIndex, invoicesAddressEditIndex } = partnerModel;
        let contactPerson = contactEditIndex != null ? ContactPersons[contactEditIndex] : {};
        let deliveriesAddress = deliveriesAddressEditIndex != null ? DeliveriesAddress[deliveriesAddressEditIndex] : {};
        let invoicesAddress = invoicesAddressEditIndex != null ? InvoicesAddress[invoicesAddressEditIndex] : {};

        return (
            <div>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-General"
                            data-toggle="tab"
                            href="#DatosMaestrosGeneral"
                            role="datosgeneral"
                            aria-controls="DatosMaestrosGeneral"
                            aria-selected="true">
                            General
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-CondPago"
                            data-toggle="tab"
                            href="#DatosMaestrosCondPago"
                            role="datoscondpago"
                            aria-controls="DatosMaestrosCondPago"
                            aria-selected="false">
                            Condición Pago
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Direcciones"
                            data-toggle="tab"
                            href="#DatosMaestrosDirecciones"
                            role="datosdirecciones"
                            aria-controls="DatosMaestrosDirecciones"
                            aria-selected="false">
                            Dirección
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-ContactPerson"
                            data-toggle="tab"
                            href="#DatosMaestrosContactPerson"
                            role="datoscontactperson"
                            aria-controls="DatosMaestrosContactPerson"
                            aria-selected="false">
                            Persona Contacto
                        </a>


                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-EjecPago"
                            data-toggle="tab"
                            href="#DatosMaestrosEjecPago"
                            role="datosejecpago"
                            aria-controls="DatosMaestrosEjecPago"
                            aria-selected="false">
                            Ejecución Pago
                        </a> */}

                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Finanzas"
                            data-toggle="tab"
                            href="#DatosMaestrosFinanzas"
                            role="datosfinanzas"
                            aria-controls="DatosMaestrosFinanzas"
                            aria-selected="false">
                            Finanzas
                        </a>
                        {/*<a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Propiedades"
                            data-toggle="tab"
                            href="#DatosMaestrosPropiedades"
                            role="datospropiedades"
                            aria-controls="DatosMaestrosPropiedades"
                            aria-selected="false">
                            Propiedades
                        </a>*/}
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Comentarios"
                            data-toggle="tab"
                            href="#DatosMaestrosComentarios"
                            role="datoscomentarios"
                            aria-controls="DatosMaestrosComentarios"
                            aria-selected="false">
                            Comentarios
                        </a> */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Anexos"
                            data-toggle="tab"
                            href="#DatosMaestrosAnexos"
                            role="datosanexos"
                            aria-controls="DatosMaestrosAnexos"
                            aria-selected="false">
                            Anexos
                        </a>
                    </div>
                </nav>
                <div className="tab-content py-3 border border-top-0 ronded-bottom" style={{ textAlign: 'left' }}>
                    {/* Genral */}
                    <div className="container tab-pane active"
                        id="DatosMaestrosGeneral"
                        role="datosgeneral"
                        aria-labelledby="nav-profile-tab-General" >
                        <div className="row">
                            <div className="col-12 col-md-6">
                                {/*Teléfono1*/}
                                <div className="input-group mb-3" id='BPG0'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Teléfono 1</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={partnerModel.Phone1 ? partnerModel.Phone1 : ""}
                                        onChange={this.changeBusinessPartnerPhone1}
                                        maxLength={9}
                                        placeholder="Solo números (máx. 9)" />
                                </div>
                                {/*Teléfono2*/}
                                <div className="input-group mb-3" id='BPG1'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Teléfono 2</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={partnerModel.Phone2 ? partnerModel.Phone2 : ""}
                                        onChange={this.changeBusinessPartnerPhone2}
                                        maxLength={9}
                                        placeholder="Solo números (máx. 9)" />
                                </div>

                                {/*correo*/}
                                <div className="input-group mb-3" id='BPG2'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Correo</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        type="email"
                                        disabled={action === 2 && !editMode}
                                        value={partnerModel.E_mail ? partnerModel.E_mail : ""}
                                        onChange={this.changeCorreo}
                                        placeholder="ejemplo@dominio.com" />
                                </div>

                                {/*Activo*/}
                                <div className="form-group row" id='BPG3'>
                                    <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                                        <div className="radio font-weight-bold" style={{ fontSize: 13, marginTop: 0 }} >
                                            <input
                                                type="radio"
                                                name="statusGroup"
                                                disabled={action === 2 && !editMode}
                                                checked={partnerModel.validFor === 'Y' ? true : false}
                                                id="enableRadio"
                                                onChange={() => this.changePartnerActive('Y')}
                                            />
                                            <label for='enableRadio' className='ml-2'>
                                                Activo
                                            </label>
                                        </div>
                                        <div className="radio font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                            <input
                                                type="radio"
                                                name="statusGroup"
                                                disabled={action === 2 && !editMode}
                                                checked={partnerModel.validFor === 'N' ? true : false}
                                                id="disableRadio"
                                                onChange={() => this.changePartnerActive('N')}
                                            />
                                            <label for='disableRadio' className='ml-2'>
                                                Inactivo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*EMPLEADO DE VENTAS*/}

                                <div className="input-group mb-3" id='BPG4'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Empleado Ventas</span>
                                            <span className="d-inline d-xl-none">Empleado</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.SlpName ? partnerModel.SlpName : ""}
                                        id="inputBPG4" />
                                    {!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            onClick={this.openEmployee}>
                                            <i className="fa fa-list" />
                                        </button>
                                    )}
                                </div>

                                {/*TERRITORIO*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Territorio</span>
                                    </div>
                                        <input
                            className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled
                                               value={partnerModel.TerritoryName ? partnerModel.TerritoryName : ""}
                                               id="txtTel2"/>
                                    {!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                            className="input-group-text"
                                            onClick={this.openTerritory}>
                                            <i className="fa fa-list" />
                                        </button>
                                    )}
                                </div> */}

                            </div>
                        </div>
                    </div>

                    {/* Persona de contacto */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosContactPerson"
                        role="datoscontactperson"
                        aria-labelledby="nav-profile-tab-ContactPerson" >
                        <div className="row ">
                            <div className="col-12 col-md-6">
                                {/*ID contacto*/}

                                <div className="input-group mb-3" id='BPCP0'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Contacto</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        readOnly
                                        value={contactPerson.Name ? contactPerson.Name : ""}
                                        id="inputBPCP0" />
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning"
                                        onClick={() => this.elementDisabled("inputBPCP0", this.openContactPersons)}>
                                        <i className="fa fa-list" />
                                    </button>
                                    {!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            disabled={action === 2 && !editMode}
                                            onClick={() => this.elementDisabled("inputBPCP0", this.addContactPersons)}>
                                            <i className="fa fa-plus" aria-hidden="true" />
                                        </button>
                                    )}
                                </div>

                                {/*estandar*/}
                                <div className="input-group mb-3" id='BPCP1'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Contacto default</span>
                                            <span className="d-inline d-xl-none">Contacto Default</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.CntctPrsn ? partnerModel.CntctPrsn : ""} />
                                </div>


                            </div>


                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">

                                {/*ID contacto*/}
                                <div className="input-group mb-3" id='BPCP2'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">ID Contacto</span>
                                            <span className="d-inline d-xl-none">ID Contacto</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Name ? contactPerson.Name : ""}
                                        onChange={this.changeIDContacto} />
                                    {/*!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            style={{backgroundColor: 'transparent', color: 'red'}}
                                            className="btn"
                                            disabled={action === 2 && !editMode}
                                            onClick={()  => this.deleteContactPersons(contactPerson.Name)}>
                                            <i className="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                    )*/}
                                </div>

                                {/*Nombre*/}
                                <div className="input-group mb-3" id='BPCP3'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Nombre</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.FirstName ? contactPerson.FirstName : ""}
                                        onChange={this.changeFirstName} />
                                </div>

                                {/*Segundo Nombre*/}
                                <div className="input-group mb-3" id='BPCP5'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Segundo Nombre</span>
                                            <span className="d-inline d-xl-none">Segundo Nombre</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.MiddleName ? contactPerson.MiddleName : ""}
                                        onChange={this.changeMiddleName} />
                                </div>

                                {/*Apellido*/}
                                <div className="input-group mb-3" id='BPCP7'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Apellido</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.LastName ? contactPerson.LastName : ""}
                                        onChange={this.changeLastName} />
                                </div>

                                {/*Título*/}
                                <div className="input-group mb-3" id='BPCP4'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Título</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Title ? contactPerson.Title : ""}
                                        onChange={this.changeTitle} />
                                </div>

                                {/*Posición*/}
                                <div className="input-group mb-3" id='BPCP6'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Posición</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Position ? contactPerson.Position : ""}
                                        onChange={this.changePosition} />
                                </div>

                                {/*Dirección*/}
                                <div className="input-group mb-3" id='BPCP17'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Dirección</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Address ? contactPerson.Address : ""}
                                        onChange={this.changeContactAddress} />
                                </div>


                                {/*Teléfono 1*/}
                                <div className="input-group mb-3" id='BPCP8'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Teléfono 1</span>
                                            <span className="d-inline d-xl-none">Teléfono 1</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Tel1 ? contactPerson.Tel1 : ""}
                                        onChange={this.changeTel1}
                                        maxLength={9}
                                        placeholder="Solo números (máx. 9)" />
                                </div>

                                {/*Teléfono 2*/}
                                <div className="input-group mb-3" id='BPCP9'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Teléfono 2</span>
                                            <span className="d-inline d-xl-none">Teléfono 2</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Tel2 ? contactPerson.Tel2 : ""}
                                        onChange={this.changeTel2}
                                        maxLength={9}
                                        placeholder="Solo números (máx. 9)" />
                                </div>

                                {/*Teléfono móvil*/}
                                <div className="input-group mb-3" id='BPCP10'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Teléfono móvil</span>
                                            <span className="d-inline d-xl-none">Móvil</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Cellolar ? contactPerson.Cellolar : ""}
                                        onChange={this.changeCellolar}
                                        maxLength={9}
                                        placeholder="Solo números (máx. 9)" />
                                </div>

                                {/*Fax*/}
                                <div className="input-group mb-3" id='BPCP11'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Fax</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Fax ? contactPerson.Fax : ""}
                                        onChange={this.changeFax} />
                                </div>

                                {/*Correo electrónico*/}
                                <div className="input-group mb-3" id='BPCP12'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Correo electrónico</span>
                                            <span className="d-inline d-xl-none">Correo</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode} value={contactPerson.E_MailL ? contactPerson.E_MailL : ""}
                                        onChange={this.changeE_mail}
                                        placeholder="ejemplo@dominio.com" />
                                </div>

                                {/*Busca*/}
                                <div className="input-group mb-3" id='BPCP19'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Busca</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Pager ? contactPerson.Pager : ""}
                                        onChange={this.changePager} />
                                </div>

                                {/*Observaciones 1*/}
                                <div className="input-group mb-3" id='BPCP13'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Observaciones 1</span>
                                            <span className="d-inline d-xl-none">Observacion 1</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Notes1 ? contactPerson.Notes1 : ""}
                                        onChange={this.changeNotes1} />
                                </div>

                                {/*Observaciones 2*/}
                                <div className="input-group mb-3" id='BPCP14'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Observaciones 2</span>
                                            <span className="d-inline d-xl-none">Observacion 2</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Notes2 ? contactPerson.Notes2 : ""}
                                        onChange={this.changeNotes2} />
                                </div>

                                {/*Clave de acceso*/}
                                <div className="input-group mb-3" id='BPCP20'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Clave de acceso</span>
                                            <span className="d-inline d-xl-none">Clave Acceso</span>
                                        </span>
                                    </div>
                                    <input
                                        type="password"
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Password ? contactPerson.Password : ""}
                                        onChange={this.changePassword} />
                                </div>

                                {/*Sexo*/}
                                <div className="input-group mb-3" id='BPCP23'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Sexo</span>
                                    </div>
                                    <select
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Gender || ""}
                                        onChange={this.changeGender}>
                                        <option value="">Seleccionar...</option>
                                        <option value="M">Masculino</option>
                                        <option value="F">Femenino</option>
                                    </select>
                                </div>

                                {/*Profesión*/}
                                <div className="input-group mb-3" id='BPCP24'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Profesión</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.Profession ? contactPerson.Profession : ""}
                                        onChange={this.changeProfession} />
                                </div>

                                {/*Fecha de nacimiento*/}
                                <div className="input-group mb-3" id='BPCP25'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Fecha de Nacimiento</span>
                                            <span className="d-inline d-xl-none">Nacimiento</span>
                                        </span>
                                    </div>
                                    <input
                                        type="date"
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.DateOfBirth ? contactPerson.DateOfBirth : ""}
                                        onChange={this.changeBirthDate} />
                                </div>

                                {/*Aval*/}
                                <div className="input-group mb-3" id='BPCP27'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Aval</span>
                                    </div>
                                    <select
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        value={contactPerson.U_AvalSN || ""}
                                        onChange={this.changeAval}>
                                        <option value="">Seleccionar...</option>
                                        <option value="1">Sí</option>
                                        <option value="2">No</option>
                                    </select>
                                </div>

                                {/*Active*/}
                                <div className="input-group mb-3" id='BPCP15'>
                                    <label htmlFor="txtContactPerson" className="font-weight-bold"> Activo: </label>
                                    <input
                                        type="checkbox"
                                        disabled={action === 2 && !editMode}
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        id="cbox1"
                                        className="ml-2"
                                        checked={contactPerson.Active == 'Y' ? true : false}
                                        onChange={this.changeActiveContact} />
                                </div>

                                {/*fijar como estandar*/}
                                <div className="input-group mb-3" id='BPCP16'>
                                    <label htmlFor="txtContactPerson" className="font-weight-bold">
                                        <span className="d-none d-xl-inline">Fijar como estándar:</span>
                                        <span className="d-inline d-xl-none">Fijar Estándar:</span>
                                    </label>
                                    {!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="btn"
                                            onClick={this.changeContactDefault}>
                                            <i className="fas fa-check" aria-hidden="true" />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Direcciones */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosDirecciones"
                        role="datosdirecciones"
                        aria-labelledby="nav-profile-tab-Direcciones" >
                        <div>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active"
                                        id="nav-profile-tab-dirFacturacion"
                                        data-toggle="tab"
                                        href="#dirfactura"
                                        role="direccionfactura"
                                        aria-controls="dirfactura"
                                        aria-selected="true">
                                        Dirección de Facturación
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary "
                                        id="nav-profile-tab-dirEntregas"
                                        data-toggle="tab"
                                        href="#direntrega"
                                        role="direccionentrega"
                                        aria-controls="direntrega"
                                        aria-selected="false">
                                        Dirección de Entrega
                                    </a>
                                </div>
                            </nav>
                            <div className="tab-content border border-top-0 rounded-bottom" style={{ textAlign: 'left' }}>
                                <div className="container tab-pane pt-3 show active"
                                    id="dirfactura"
                                    role="direccionfactura"
                                    aria-labelledby="nav-profile-tab-dirFacturacion" >
                                    <div className="row">

                                            {/*Facturacion*/}
                                        <div className="col-12 col-md-6 mb-3">
                                            <div className="input-group mb-3" id='BPIA0'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Dir. Factura</span>
                                                        <span className="d-inline d-xl-none">Dir Factura</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={invoicesAddress.Address ? invoicesAddress.Address : ""} />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    onClick={() => this.openAddresses('invoices')}>
                                                    <i className="fa fa-list" />
                                                </button>
                                                {!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-success"
                                                        disabled={action === 2 && !editMode}
                                                        onClick={() => this.addAddresses('invoices')}>
                                                        Agregar
                                                    </button>
                                                )}
                                            </div>


                                            {/*invoices*/}
                                            <div className="input-group mb-3" id='BPIA1'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Facturación estándar</span>
                                                        <span className="d-inline d-xl-none">Fact Estándar</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={partnerModel.BillToDef ? partnerModel.BillToDef : ""} />
                                            </div>
                                        </div>
                                        {/*segunda columna*/}
                                        <div className="col-12 col-md-6">

                                            {/*ID direccion*/}
                                            <div className="input-group mb-3" id='BPIA2'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Alias</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.Address ? invoicesAddress.Address : ""}
                                                    onChange={(event) => this.changeAddress(event, 'invoices')} />
                                            </div>

                                            {/*Address2*/}
                                            {/*<div className="input-group mb-3" id='BPIA3'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" title='Nombre de la Dirección 2'>Nombre Dirección 2</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.Address2 ? invoicesAddress.Address2 : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'Address2', 'invoices')} />
                                            </div>*/}
                                            {/*Address3*/}
                                            {/*<div className="input-group mb-3" id='BPIA4'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" title='Nombre de la Dirección 3'>Nombre Dirección 3</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.Address3 ? invoicesAddress.Address3 : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'Address3', 'invoices')} />
                                            </div>*/}

                                            {/*Pais*/}
                                            <div className="input-group mb-3" id='BPIA3'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">País</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    value={invoicesAddress.Country ? invoicesAddress.Country : "PE"} id="txtTel2" />
                                                {/* {!(action === 2 && !editMode) && (
                                                    <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                    className="input-group-text"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.openCountry('invoices')}>
                                                    <i className="fa fa-list" />
                                                    </button>
                                                )} */}
                                            </div>

                                            {/*State*/}
                                            <div className="input-group mb-3" id='BPIA4'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Departamento</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    value={invoicesAddress.State ? invoicesAddress.State : ""} id="txtTel2" />
                                                {!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={action === 2 && !editMode}
                                                        onClick={() => this.openState('invoices')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*County*/}
                                            {/* <div className="input-group mb-3" id='BPIA5'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Provincia</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={invoicesAddress.County ? invoicesAddress.County : ""}
                                                    onChange={(event) => this.changeCounty(event, 'invoices')} />
                                            </div> */}

                                            {/*City*/}
                                            <div className="input-group mb-3" id='BPIA7'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Provincia</span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.County ? invoicesAddress.County : ""}
                                                    onChange={(event) => this.handleProvinciaChange(event, 'invoices')}>
                                                    <option value="">-- Seleccionar Provincia --</option>
                                                    {/* ← AGREGAR */}
                                                    {invoicesAddress.County &&
                                                        (!invoicesAddress.provinciasInvoices ||
                                                            invoicesAddress.provinciasInvoices.length === 0) && (
                                                            <option value={invoicesAddress.County}>
                                                                {invoicesAddress.County}
                                                            </option>
                                                        )}
                                                    {!!invoicesAddress.provinciasInvoices && invoicesAddress.provinciasInvoices.map((prov, index) => (
                                                        <option key={index} value={prov.U_RS_PROVINCIA}>
                                                            {prov.U_RS_PROVINCIA}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/*Block*/}
                                            <div className="input-group mb-3" id='BPIA6'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Distrito</span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.City ? invoicesAddress.City : ""}
                                                    onChange={(event) => this.handleDistritoChange(event, 'invoices')}>
                                                    <option value="">-- Seleccionar Distrito --</option>
                                                    {invoicesAddress.City &&
                                                        (!invoicesAddress.distritosInvoices || invoicesAddress.distritosInvoices.length === 0) && (
                                                            <option value={invoicesAddress.City}>
                                                                {invoicesAddress.City}
                                                            </option>
                                                        )}
                                                    {!!invoicesAddress.distritosInvoices && invoicesAddress.distritosInvoices.map((dist, index) => (
                                                        <option key={index} value={dist.U_RS_DISTRITO}>
                                                            {dist.U_RS_DISTRITO}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/*Street*/}
                                            <div className="input-group mb-3" id='BPIA8'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Calle / Número</span>
                                                        <span className="d-inline d-xl-none">Calle / Nro</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.Street ? invoicesAddress.Street : ""}
                                                    onChange={(event) => this.changeStreet(event, 'invoices')} />
                                            </div>

                                            {/*ZipCode*/}
                                            <div className="input-group mb-3" id='BPIA9'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Ubigeo</span>
                                                </div>
                                                <div className="form__group-input flex-grow-1">
                                                    <input type="text" className="form-control form__input"
                                                        disabled={true}
                                                        readOnly
                                                        value={invoicesAddress.ZipCode ? invoicesAddress.ZipCode : ""}
                                                        id="input__BPIA8" />
                                                    <i className="form__validation-state fa fa-times-circle"></i>
                                                </div>
                                            </div>



                                            {/*TaxCode
                                            <div className="form-group row" id="div1">
                                                <label htmlFor="txtContactPerson"
                                                       className="col-md-4 col-sm-12 col-form-label font-weight-bold">Impuesto: </label>
                                                <div className="col-md-6 col-sm-12">
                                                    <input type=" text" className="form-control btn-outline-secondary"
                                                           style={{
                                                               backgroundColor: 'transparent',
                                                               borderColor: '#ced4da',
                                                               color: '#000'
                                                           }}
                                                           disabled={action === 2 && !editMode}
                                                           value={invoicesAddress.TaxCode ? invoicesAddress.TaxCode : ""}
                                                           onChange={(event) => this.changeTaxCode(event, 'invoices')}
                                                           id="txtTel2"/>
                                                </div>
                                            </div>*/}

                                            {/*StreetNo*/}
                                            {/*<div className="input-group mb-3" id='BPIA10'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">No. Calle</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.StreetNo ? invoicesAddress.StreetNo : ""}
                                                    onChange={(event) => this.changeStreetNo(event, 'invoices')} />
                                            </div>*/}

                                            {/*Building*/}
                                            {/*<div className="input-group mb-3" id='BPIA11'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Edificio/Planta/Sale</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.Building ? invoicesAddress.Building : ""}
                                                    onChange={(event) => this.changeBuilding(event, 'invoices')} />
                                            </div>*/}

                                            {/*GlblLocNum*/}
                                            {/*<div className="input-group mb-3" id='BPIA12'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">GLN</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.GlblLocNum ? invoicesAddress.GlblLocNum : ""}
                                                    onChange={(event) => this.changeGlblLocNum(event, 'invoices')} />
                                            </div>*/}

                                            {/*U_Descripcion*/}
                                            {/* <div className="input-group mb-3" id='BPIA13'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Descripción</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_Descripcion ? invoicesAddress.U_Descripcion : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_Descripcion', 'invoices')} />
                                            </div> */}
                                            {/*U_FMB_GPSLat*/}
                                            <div className="input-group mb-3" id='BPIA10'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Latitud</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_FMB_GPSLat ? invoicesAddress.U_FMB_GPSLat : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_GPSLat', 'invoices')}
                                                    onBlur={(event) => this.changeBlurAddressValue(event.target.value, 'U_FMB_GPSLat', 'invoices')} />
                                                {(invoicesAddress?.Address ?? '') != '' ? <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.openMap(invoicesAddress, 'invoices')}>
                                                    <i className="fa fa-map-marker" />
                                                </button> : <></>}
                                            </div>
                                            {/*U_FMB_GPSLon*/}
                                            <div className="input-group mb-3" id='BPIA11'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Longitud</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_FMB_GPSLon ? invoicesAddress.U_FMB_GPSLon : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_GPSLon', 'invoices')}
                                                    onBlur={(event) => this.changeBlurAddressValue(event.target.value, 'U_FMB_GPSLon', 'invoices')} />
                                                {(invoicesAddress?.Address ?? '') != '' ? <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.openMap(invoicesAddress, 'invoices')}>
                                                    <i className="fa fa-map-marker" />
                                                </button> : <></>}
                                            </div>

                                            {/*U_FMB_RUTA*/}
                                            <div className="input-group mb-3" id='BPIA12'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Ruta Asignada</span>
                                                        <span className="d-inline d-xl-none">Ruta Asignada</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_FMB_RUTA ? invoicesAddress.U_FMB_RUTA : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_RUTA', 'invoices')} />
                                            </div>

                                            {/*U_FMB_Project*/}
                                            <div className="input-group mb-3" id='BPIA13'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Proyecto</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={invoicesAddress?.U_FMB_Project || ""} />
                                                {invoicesAddress?.Address &&
                                                    <button type="button" className="btn btn-outline-warning" disabled={!(action === 2 && editMode)} onClick={() => action === 2 && editMode && this.openProjects('invoices')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                }
                                            </div>
                                            {/*U_FMB_FICHA_OSIN*/}
                                            <div className="input-group mb-3" id='BPIA14'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Ficha Osinergmin</span>
                                                        <span className="d-inline d-xl-none">Ficha Osinergmin</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_FMB_FICHA_OSIN ? invoicesAddress.U_FMB_FICHA_OSIN : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_FICHA_OSIN', 'invoices')} />

                                                {/*<button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.validateOSIN(invoicesAddress?.U_FMB_FICHA_OSIN ?? '', 'invoices')}>
                                                    <i className="fa fa-search" />
                                                </button>*/}
                                            </div>
                                            {/*U_FMB_OSIN_CAPACIDAD*/}
                                            <div className="input-group mb-3" id='BPIA15'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Capacidad</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={invoicesAddress.U_FMB_OSIN_CAPACIDAD ? invoicesAddress.U_FMB_OSIN_CAPACIDAD : ""} />
                                            </div>
                                            {/*U_FMB_OSIN_STATUS*/}
                                            <div className="input-group mb-3" id='BPIA16'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Estado</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={invoicesAddress.U_FMB_OSIN_STATUS ? invoicesAddress.U_FMB_OSIN_STATUS : ""} />
                                            </div>

                                            {/*ID Instalación*/}
                                            <div className="input-group mb-3" id='BPIA17'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">ID Instalación</span>
                                                        <span className="d-inline d-xl-none">ID Instalación</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_RMO_ID_DIRE ? invoicesAddress.U_RMO_ID_DIRE : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_RMO_ID_DIRE', 'invoices')} />
                                            </div>
                                            {/*U_FMB_OSIN_TIPAGENT*/}
                                            <div className="input-group mb-3" id='BPIA18'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Tipo Agente</span>
                                                        <span className="d-inline d-xl-none">Tipo Agente</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={invoicesAddress.U_FMB_OSIN_TIPAGENT ? invoicesAddress.U_FMB_OSIN_TIPAGENT : ""} />
                                            </div>

                                            {/*ID Dir. Cesión Uso*/}
                                            <div className="input-group mb-3" id='BPIA19'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">ID Dir. Cesión Uso</span>
                                                        <span className="d-inline d-xl-none">ID Cesión Uso</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={invoicesAddress.U_RML_IDDIR_CU ? invoicesAddress.U_RML_IDDIR_CU : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_RML_IDDIR_CU', 'invoices')} />
                                            </div>

                                            {/*Fijar como estándar*/}
                                            <div className="input-group mb-3 align-items-center" id='BPIA20'>
                                                <label htmlFor="txtContactPerson" className="font-weight-bold mb-0 mr-2">
                                                    <span className="d-none d-xl-inline">Fijar como estándar:</span>
                                                    <span className="d-inline d-xl-none">Fijar Estándar:</span>
                                                </label>
                                                {!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="btn"
                                                        onClick={() => this.changeAddressDefault('invoices')}>
                                                        <i className="fas fa-check" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div className="container tab-pane pt-3"
                                    id="direntrega"
                                    role="direccionentrega"
                                    aria-labelledby="nav-profile-tab-dirEntregas" >

                                    <div className="row">

                                            {/*Entrega*/}
                                        <div className="col-12 col-md-6 mb-3">
                                            <div className="input-group mb-3" id='BDA0'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Dir. Entrega</span>
                                                        <span className="d-inline d-xl-none">Dir Entrega</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={deliveriesAddress.Address ? deliveriesAddress.Address : ""} />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    onClick={() => this.openAddresses('deliveries')}>
                                                    <i className="fa fa-list" />
                                                </button>
                                                {!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-success"
                                                        onClick={() => this.addAddresses('deliveries')}>
                                                        Agregar
                                                        {/* <i className="fa fa-plus" aria-hidden="true"/> */}
                                                    </button>
                                                )}
                                            </div>


                                            {/*Entrega*/}
                                            <div className="input-group mb-3" id='BDA1'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Entrega estándar</span>
                                                        <span className="d-inline d-xl-none">Entr Estándar</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={partnerModel.ShipToDef ? partnerModel.ShipToDef : ""} />
                                            </div>
                                        </div>
                                        {/*segunda columna*/}
                                        <div className="col-12 col-md-6">

                                            {/*ID direccion*/}
                                            <div className="input-group mb-3" id='BDA2'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Alias</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.Address ? deliveriesAddress.Address : ""}
                                                    onChange={(event) => this.changeAddress(event, 'deliveries')} />
                                            </div>
                                            {/*Address2*/}
                                            {/*<div className="input-group mb-3" id='BDA3'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" title='Nombre de la Dirección 2'>Nombre Dirección 2</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.Address2 ? deliveriesAddress.Address2 : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'Address2', 'deliveries')} />
                                            </div>*/}
                                            {/*Address3*/}
                                            {/*<div className="input-group mb-3" id='BDA4'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" title='Nombre de la Dirección 3'>Nombre Dirección 3</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.Address3 ? deliveriesAddress.Address3 : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'Address3', 'deliveries')} />
                                            </div>*/}

                                            {/*Country*/}
                                            <div className="input-group mb-3" id='BDA3'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">País</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={deliveriesAddress.Country ? deliveriesAddress.Country : "PE"} id="txtTel2" />
                                                {/*{!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={action === 2 && !editMode}
                                                        onClick={() => this.openCountry('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )} */}
                                            </div>

                                            {/*State*/}
                                            <div className="input-group mb-3" id='BDA4'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Departamento</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    value={deliveriesAddress.State ? deliveriesAddress.State : ""} id="txtTel2" />
                                                {!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={action === 2 && !editMode}
                                                        onClick={() => this.openState('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*County*/}
                                            {/* <div className="input-group mb-3" id='BDA5'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Provincia</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={deliveriesAddress.County ? deliveriesAddress.County : ""}
                                                    onChange={(event) => this.changeCounty(event, 'deliveries')} />
                                            </div> */}
                                            {/*City*/}
                                            <div className="input-group mb-3" id='BDA7'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Provincia</span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.County ? deliveriesAddress.County : ""}
                                                    onChange={(event) => this.handleProvinciaChange(event, 'deliveries')}>
                                                    <option value="">-- Seleccionar Provincia --</option>
                                                    {deliveriesAddress.County &&
                                                        (!deliveriesAddress.provinciasDeliveries || deliveriesAddress.provinciasDeliveries.length === 0) && (
                                                            <option value={deliveriesAddress.County}>
                                                                {deliveriesAddress.County}
                                                            </option>
                                                        )}
                                                    {!!deliveriesAddress.provinciasDeliveries && deliveriesAddress.provinciasDeliveries.map((prov, index) => (
                                                        <option key={index} value={prov.U_RS_PROVINCIA}>
                                                            {prov.U_RS_PROVINCIA}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            {/*Block*/}
                                            <div className="input-group mb-3" id='BDA6'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Distrito</span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.City ? deliveriesAddress.City : ""}
                                                    onChange={(event) => this.handleDistritoChange(event, 'deliveries')}>
                                                    <option value="">-- Seleccionar Distrito --</option>
                                                    {deliveriesAddress.City &&
                                                        (!deliveriesAddress.distritosDeliveries ||
                                                            deliveriesAddress.distritosDeliveries.length === 0) && (
                                                            <option value={deliveriesAddress.City}>
                                                                {deliveriesAddress.City}
                                                            </option>
                                                        )}
                                                    {!!deliveriesAddress.distritosDeliveries && deliveriesAddress.distritosDeliveries.map((dist, index) => (
                                                        <option key={index} value={dist.U_RS_DISTRITO}>
                                                            {dist.U_RS_DISTRITO}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>



                                            {/*Street*/}
                                            <div className="input-group mb-3" id='BDA8'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Calle / Número</span>
                                                        <span className="d-inline d-xl-none">Calle / Nro</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.Street ? deliveriesAddress.Street : ""}
                                                    onChange={(event) => this.changeStreet(event, 'deliveries')} />
                                            </div>

                                            {/*ZipCode*/}
                                            <div className="input-group mb-3" id='BDA9'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Ubigeo</span>
                                                </div>
                                                <div className="form__group-input flex-grow-1">
                                                    <input type="text" className="form-control form__input"
                                                        disabled={true}
                                                        readOnly
                                                        value={deliveriesAddress.ZipCode ? deliveriesAddress.ZipCode : ""}
                                                        id="input__BDA8"
                                                    />
                                                    <i className="form__validation-state fa fa-times-circle"></i>
                                                </div>
                                            </div>
                                            {/*StreetNo*/}
                                            {/*<div className="input-group mb-3" id='BDA13'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">No. Calle</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.StreetNo ? deliveriesAddress.StreetNo : ""}
                                                    onChange={(event) => this.changeStreetNo(event, 'deliveries')} />
                                            </div>*/}

                                            {/*Building*/}
                                            {/*<div className="input-group mb-3" id='BDA14'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Edificio/Planta/Sale</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.Building ? deliveriesAddress.Building : ""}
                                                    onChange={(event) => this.changeBuilding(event, 'deliveries')} />
                                            </div>*/}
                                            {/*GlblLocNum*/}
                                            {/*<div className="input-group mb-3" id='BDA16'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">GLN</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.GlblLocNum ? deliveriesAddress.GlblLocNum : ""}
                                                    onChange={(event) => this.changeGlblLocNum(event, 'deliveries')} />
                                            </div>*/}

                                            {/*U_Descripcion*/}
                                            {/* <div className="input-group mb-3" id='BPIA12'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Descripción</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_Descripcion ? deliveriesAddress.U_Descripcion : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_Descripcion', 'deliveries')} />
                                            </div> */}

                                            {/*U_FMB_GPSLat*/}
                                            <div className="input-group mb-3" id='BDA10'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Latitud</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_FMB_GPSLat ? deliveriesAddress.U_FMB_GPSLat : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_GPSLat', 'deliveries')}
                                                    onBlur={(event) => this.changeBlurAddressValue(event.target.value, 'U_FMB_GPSLat', 'deliveries')}
                                                />
                                                {(deliveriesAddress?.Address ?? '') != '' ? <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.openMap(deliveriesAddress, 'deliveries')}>
                                                    <i className="fa fa-map-marker" />
                                                </button> : <></>}
                                            </div>
                                            {/*U_FMB_GPSLon*/}
                                            <div className="input-group mb-3" id='BDA11'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Longitud</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_FMB_GPSLon ? deliveriesAddress.U_FMB_GPSLon : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_GPSLon', 'deliveries')}
                                                    onBlur={(event) => this.changeBlurAddressValue(event.target.value, 'U_FMB_GPSLon', 'deliveries')}
                                                />
                                                {(deliveriesAddress?.Address ?? '') != '' ? <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.openMap(deliveriesAddress, 'deliveries')}>
                                                    <i className="fa fa-map-marker" />
                                                </button> : <></>}
                                            </div>

                                            {/*TaxCode*/}
                                            <div className="input-group mb-3" id='BDA12'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Indicador de impuesto</span>
                                                        <span className="d-inline d-xl-none">Ind Impuesto</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={deliveriesAddress.TaxCode ? deliveriesAddress.TaxCode : ""} />
                                                {!(action === 2 && !editMode) && partnerModel.CardType !== 'C' && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-warning"
                                                        disabled={action === 2 && !editMode}
                                                        onClick={() => this.openTaxes('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>
                                            {/*
                                            <div className="input-group mb-3" id='BDA13'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Hacienda</span>
                                                </div>
                                                <input type="text" className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.TaxOffice ? deliveriesAddress.TaxOffice : ""}
                                                    onChange={(event) => this.changeTaxOffice(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>
                                            */}

                                            {/*U_FMB_RUTA*/}
                                            <div className="input-group mb-3" id='BDA14'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Ruta Asignada</span>
                                                        <span className="d-inline d-xl-none">Ruta Asignada</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_FMB_RUTA ? deliveriesAddress.U_FMB_RUTA : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_RUTA', 'deliveries')} />
                                            </div>
                                            {/*U_FMB_Project*/}
                                            <div className="input-group mb-3" id='BDA15'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Proyecto</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={deliveriesAddress?.U_FMB_Project || ""} />
                                                {deliveriesAddress?.Address &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-warning"
                                                        disabled={!(action === 2 && editMode)}
                                                        onClick={() => action === 2 && editMode && this.openProjects('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                }
                                            </div>
                                            {/*U_FMB_FICHA_OSIN*/}
                                            <div className="input-group mb-3" id='BDA16'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Ficha Osinergmin</span>
                                                        <span className="d-inline d-xl-none">Ficha Osinergmin</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_FMB_FICHA_OSIN ? deliveriesAddress.U_FMB_FICHA_OSIN : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_FICHA_OSIN', 'deliveries')} />
                                                {/*<button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    disabled={action === 2 && !editMode}
                                                    onClick={() => this.validateOSIN(deliveriesAddress?.U_FMB_FICHA_OSIN ?? '', 'deliveries')}>
                                                    <i className="fa fa-search" />
                                                </button>*/}
                                            </div>
                                            {/*U_FMB_OSIN_CAPACIDAD*/}
                                            <div className="input-group mb-3" id='BDA17'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Capacidad</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={deliveriesAddress.U_FMB_OSIN_CAPACIDAD ? deliveriesAddress.U_FMB_OSIN_CAPACIDAD : ""} />
                                            </div>
                                            {/*U_FMB_OSIN_STATUS*/}
                                            <div className="input-group mb-3" id='BDA18'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Estado</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={true}
                                                    readOnly
                                                    value={deliveriesAddress.U_FMB_OSIN_STATUS ? deliveriesAddress.U_FMB_OSIN_STATUS : ""} />
                                            </div>

                                            {/* ID Instalación*/}
                                            <div className="input-group mb-3" id='BDA19'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">ID Instalación</span>
                                                        <span className="d-inline d-xl-none">ID Instalación</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_RMO_ID_DIRE ? deliveriesAddress.U_RMO_ID_DIRE : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_RMO_ID_DIRE', 'deliveries')} />
                                            </div>

                                            {/*U_FMB_OSIN_TIPAGENT*/}
                                            <div className="input-group mb-3" id='BDA20'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Tipo Agente</span>
                                                        <span className="d-inline d-xl-none">Tipo Agente</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_FMB_OSIN_TIPAGENT ? deliveriesAddress.U_FMB_OSIN_TIPAGENT : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_FMB_OSIN_TIPAGENT', 'deliveries')} />
                                            </div>

                                            {/*ID Dir. Cesión Uso*/}
                                            <div className="input-group mb-3" id='BDA21'>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">ID Dir. Cesión Uso</span>
                                                        <span className="d-inline d-xl-none">ID Cesión Uso</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={deliveriesAddress.U_RML_IDDIR_CU ? deliveriesAddress.U_RML_IDDIR_CU : ""}
                                                    onChange={(event) => this.changeAddressValue(event.target.value, 'U_RML_IDDIR_CU', 'deliveries')} />
                                            </div>

                                            {/*Fijar como estándar*/}
                                            <div className="input-group mb-3 align-items-center" id='BDA22'>
                                                <label htmlFor="txtContactPerson" className="font-weight-bold mb-0 mr-2">
                                                    <span className="d-none d-xl-inline">Fijar como estándar:</span>
                                                    <span className="d-inline d-xl-none">Fijar Estándar:</span>
                                                </label>
                                                {!(action === 2 && !editMode) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="btn"
                                                        onClick={() => this.changeAddressDefault('deliveries')}>
                                                        <i className="fas fa-check" aria-hidden="true" />
                                                    </button>
                                                )}
                                            </div>

                                        </div>
                                        </div>
                                    </div>

                            </div>
                        </div>
                    </div>

                    {/* Condiciones de Pago */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosCondPago"
                        role="datoscondpago"
                        aria-labelledby="nav-profile-tab-CondPago" >
                        <div className="row">
                            {/*Primer columna*/}
                            <div className="col-12 col-md-6 mb-3">
                                {/*condicion de pago*/}
                                <div className="input-group mb-3" id='BPC0'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Cond. de Pago</span>
                                            <span className="d-inline d-xl-none">Cond Pago</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        value={partnerModel.GroupNumName ? partnerModel.GroupNumName : ''} />
                                    {(action === 2 && editMode) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            onClick={this.openGroupNum}>
                                            <i className="fa fa-list" />
                                        </button>
                                    )}
                                </div>
                                {/*% intereses por retraso*/}
                                <div className="input-group mb-3" id='BPC0A'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">% Intereses por Retraso</span>
                                            <span className="d-inline d-xl-none">% Int Retraso</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.IntrstRate || ''} />
                                </div>
                                {/*lista de precios*/}
                                <div className="input-group mb-3" id='BPC1'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Lista de Precios</span>
                                            <span className="d-inline d-xl-none">Lista Precios</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.PriceListNumName ? partnerModel.PriceListNumName : ''} />
                                    {!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            onClick={this.openListNum}
                                            disabled={partnerModel.GroupCode === 100}>
                                            <i className="fa fa-list" />
                                        </button>
                                    )}
                                </div>
                                {/*% descuento total*/}
                                <div className="input-group mb-3" id='BPC1A'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">% Descuento Total</span>
                                            <span className="d-inline d-xl-none">% Descuento</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.Discount || ''} />
                                </div>
                                {/*País del banco*/}
                                <div className="input-group mb-3" id='BPC2'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">País del banco</span>
                                            <span className="d-inline d-xl-none">País Banco</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.BankCountr || ""} />
                                    {!(action === 2 && !editMode) &&
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            onClick={() => this.openBankAccount('invoices')}>
                                            <i className="fa fa-list" />
                                        </button>
                                    }
                                </div>
                                {/*Nombre del banco*/}
                                <div className="input-group mb-3" id='BPC3'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Nombre del banco</span>
                                            <span className="d-inline d-xl-none">Nombre Banco</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.BankCode || ""} />

                                </div>
                                {/*Código bancario*/}
                                <div className="input-group mb-3" id='BPC4'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Código bancario</span>
                                            <span className="d-inline d-xl-none">Código Banco</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.DefaultBankCode || ''}
                                        id="txtDefaultBankCode" />
                                </div>
                                {/*Cuenta*/}
                                <div className="input-group mb-3" id='BPC5'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Cuenta</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.DflAccount || ''} />
                                </div>
                                {/*Código BIC/SWIFT*/}
                                <div className="input-group mb-3" id='BPC6'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Código BIC/SWIFT</span>
                                            <span className="d-inline d-xl-none">BIC/SWIFT</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.DflSwift || ''} />
                                </div>

                                {/*Sucursal*/}
                                <div className="input-group mb-3" id='BPC7'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Sucursal</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.DflBranch || ''} />
                                </div>
                                {/*ID int.ctrl.*/}
                                <div className="input-group mb-3" id='BPC8'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">ID int.ctrl.</span>
                                            <span className="d-inline d-xl-none">ID Control</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.BankCtlKey || ''} />
                                </div>
                                {/*IBAN*/}
                                <div className="input-group mb-3" id='BPC9'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">IBAN</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={partnerModel.DflIBAN || ''} />
                                </div>
                            </div>
                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*limite de credito*/}
                                <div className="input-group mb-3" id='BPC10'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Límite crédito</span>
                                            <span className="d-inline d-xl-none">Límite Crédito</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        onChange={this.changeCreditLine}
                                        onBlur={this.validateCreditLineNull}
                                        value={partnerModel.CreditLineShow || ""} />
                                </div>
                                {/*limite comprometido*/}
                                <div className="input-group mb-3" id='BPC11'>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Límite compra</span>
                                            <span className="d-inline d-xl-none">Límite Compra</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        onChange={this.changeDebitLine}
                                        onBlur={this.validateDebitLineNull}
                                        value={partnerModel.DebtLineShow || ""} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Ejecucion de Pago */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosEjecPago"
                        role="datosejecpago"
                        aria-labelledby="nav-profile-tab-EjecPago">


                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">

                                {/*limite de credito*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Info. de referencia</span>
                                            <span className="d-inline d-xl-none">Info Referencia</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled={action === 2 && !editMode}
                                        onChange={this.changeRefDetails}
                                        value={partnerModel.RefDetails} />
                                </div>
                                {/*metodo Pago*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Método de pago</span>
                                            <span className="d-inline d-xl-none">Método Pago</span>
                                        </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        value={partnerModel.PymCodeName ? partnerModel.PymCodeName : ''} />
                                    {!(action === 2 && !editMode) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning"
                                            onClick={this.openPayMethod}>
                                            <i className="fa fa-list" />
                                        </button>
                                    )}
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                            </div>
                        </div>

                    </div>

                    {/* Propiedades */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosPropiedades"
                        role="datospropiedades"
                        aria-labelledby="nav-profile-tab-Propiedades"
                    //style={{maxHeight: 500}}
                    >
                        <div className="table-responsive">
                        <table
                            id="DatosMaestrosPropiedades"
                            className="display"
                            style={{ width: '100%', marginBottom: 40 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td style={{ backgroundColor: '#d2ab24', width: 200 }}>
                                        #
                                    </td>
                                    <td style={{ maxWidth: 500, backgroundColor: '#d2ab24' }}>
                                        Nombre de la Propiedad
                                    </td>
                                    <td style={{ backgroundColor: '#d2ab24', width: 100 }}>
                                        <input type="checkbox"></input>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{
                                    maxHeight: 10,
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                }}>
                                    {/*#*/}
                                    <td>
                                        <input
                                            type=" text"
                                            className=" form-control btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                maxWidth: '100%',
                                                textAlign: "center",
                                            }}
                                        />
                                    </td>
                                    {/*codigo*/}
                                    <td style={{ textAlign: 'center' }}>
                                        <input
                                            type=" text"
                                            className=" form-control btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                maxWidth: '100%',
                                                textAlign: "center",
                                            }}
                                        />
                                    </td>
                                    {/*check*/}
                                    <td style={{ textAlign: "center" }}>
                                        <input type="checkbox"></input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                    {/* Finanzas */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosFinanzas"
                        role="datosfinanzas"
                        aria-labelledby="nav-profile-tab-Direcciones" >
                        <div>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active"
                                        id="nav-profile-tab-confgeneral"
                                        data-toggle="tab"
                                        href="#confgeneral"
                                        role="confgeneral"
                                        aria-controls="confgeneral"
                                        aria-selected="true">
                                        General
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary "
                                        id="nav-profile-tab-confimpuesto"
                                        data-toggle="tab"
                                        href="#confimpuesto"
                                        role="confimpuesto"
                                        aria-controls="confimpuesto"
                                        aria-selected="false">
                                        Impuesto
                                    </a>
                                </div>
                            </nav>
                            <div className="tab-content border border-top-0 ronded-bottom" style={{ textAlign: 'left' }}>
                                <div className="container tab-pane fade show active"
                                    id="confgeneral"
                                    role="confgeneral"
                                    aria-labelledby="nav-profile-tab-confgeneral" >
                                    <div className="row">
                                        <div className="col-12 col-md-9 pt-3">
                                            {/*Consolidación*/}
                                            <div className="input-group mb-3">
                                                <form>
                                                    <input className="mr-2" type="radio" id="paymentRadio" name="fav_language" disabled={action === 2 && !editMode} checked={partnerModel.FatherType === 'P'} value="P" onChange={(event) => this.onChangeValueConsolidacion2(event)} />
                                                    <label className="mr-5" forhtml="paymentRadio"> Consolidación de pagos</label>

                                                    <input className="mr-2" type="radio" id="deliveryRadio" name="fav_language" disabled={action === 2 && !editMode} checked={partnerModel.FatherType === 'D'} value="D" onChange={(event) => this.onChangeValueConsolidacion2(event)} />
                                                    <label className="mr-5" forhtml="deliveryRadio"> Consolidación de entregas</label>
                                                </form>
                                            </div>

                                            {/*SN de Consolidación*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidacion">{partnerModel.CardType === 'S' ? 'Proveedores' : 'Clientes'}</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={partnerModel.DebPayAcct ? `${partnerModel.DebPayAcct} - ${partnerModel.DebPayAcctName}` : ""} />
                                                {/* {!(action === 2 && !editMode) &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-warning"
                                                        onClick={() => this.openCuentaMayor(1)}>

                                                        <i className="fa fa-list" />
                                                    </button>
                                                } */}
                                            </div>

                                            {/* CUENTA COMPENSACION DE ANTICIPO */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Compensación de anticipo</span>
                                                        <span className="d-inline d-xl-none">Comp Anticipo</span>
                                                    </span>
                                                </div>
                                                <Select
                                                    menuPlacement="auto"
                                                    options={glAccountsSelect}
                                                    value={glAccountsSelect.find(acct => acct.value === partnerModel.DownPaymentClearAct) || null}
                                                    onChange={(opt) => this.ChangeDpmClear(opt ? opt.value : null)}
                                                    placeholder="Escribe una cuenta"
                                                    isDisabled={action === 2 && !editMode}
                                                    isSearchable
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1 }),
                                                        control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                        singleValue: (base) => ({ ...base, color: "#000" })
                                                    }}
                                                />

                                                {/* <select
                                                    name="select"
                                                    className="form-control"
                                                    id="selectProject"
                                                    disabled={action === 2 && !editMode}
                                                    value={partnerModel.DownPaymentClearAct || ""}
                                                    onChange={(event) => this.ChangeDpmClear(event.target.value)} >
                                                    <option value="">Seleccionar</option>
                                                    {MajorAccounts && MajorAccounts.map(acct => {
                                                        return (
                                                            <option value={acct.AcctCode}>{acct.AcctCode} .- {acct.AcctName}</option>
                                                        )
                                                    })}
                                                </select> */}
                                            </div>

                                            {/* CUENTA PROVISIONAL DE ANTICIPO */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <span className="d-none d-xl-inline">Provisional de anticipo</span>
                                                        <span className="d-inline d-xl-none">Provi Anticipo</span>
                                                    </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    id="selectProject"
                                                    value={`${partnerModel.DownPaymentInterimAccount || ""} - ${partnerModel.DownPaymentInterimAccountName || ""}`} />
                                                {/* <select
                                                    name="select"
                                                    className="form-control"
                                                    id="selectProject"
                                                    disabled={action === 2 && !editMode}
                                                    value={`${partnerModel.DownPaymentInterimAccount || ""} - ${partnerModel.DownPaymentInterimAccountName || ""}`}
                                                    onChange={(event) => this.ChangeDpmIntAct(event.target.value)} >
                                                    <option value="">Seleccionar</option>
                                                    {MajorAccounts && MajorAccounts.map(acct => {
                                                        return (
                                                            <option value={acct.AcctCode}>{acct.AcctCode} .- {acct.AcctName}</option>
                                                        )
                                                    })}
                                                </select> */}
                                            </div>

                                            {/*SN de Consolidación*/}
                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidación">Cuenta de compensacón de artículos</span>
                                                </div>
                                                <input type=" text" className="form-control btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000'
                                                        }}
                                                        disabled
                                                        value={invoicesAddress.Address ? invoicesAddress.Address : ""}
                                                        id="txtTel2"/>
                                                <button
                                                    type="button"
                                                    style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                    className="input-group-text"
                                                    onClick={() => this.openAddresses('invoices')}>
                                                    <i className="fa fa-list" />
                                                </button>
                                                {(
                                                <label> Lusi David Rocha Zeron</label>
                                                )}
                                            </div> */}

                                            {/*SN de Consolidación*/}
                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidacion">Cuenta provisional de anticipos</span>
                                                </div>
                                                <input type=" text" className="form-control btn-outline-secondary"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000'
                                                        }}
                                                        disabled
                                                        value={invoicesAddress.Address ? invoicesAddress.Address : ""}
                                                        id="txtTel2"/>
                                                <button
                                                    type="button"
                                                    style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                    className="input-group-text"
                                                    onClick={() => this.openAddresses('invoices')}>
                                                    <i className="fa fa-list" />
                                                </button>
                                                {(
                                                <label> Lusi David Rocha Zeron</label>
                                                )}
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="container tab-pane fade pt-3" id="confimpuesto" role="confimpuesto">
                                    <div className="row">
                                        {/* Consolidación Obligatorio */}
                                        <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text font-weight-bold">
                                                        <input
                                                            id="idObli"
                                                            type="radio"
                                                            name="fav_language"
                                                            disabled={action === 2 && !editMode}
                                                            value="Y"
                                                            checked={partnerModel.VatStatus === 'Y'}
                                                            onChange={(event) => this.onChangeValueConsolidacion(event)} />
                                                    </div>
                                                </div>
                                                {action === 2 && !editMode ? <input className="form-control" readOnly disabled value="Obligatorio" />
                                                    : <label className="form-control" htmlFor="idObli"> Obligatorio </label>
                                                }
                                            </div>
                                        </div>

                                        {/* Consolidación Extranjeros */}
                                        <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text font-weight-bold">
                                                        <input
                                                            id="idExt"
                                                            type="radio"
                                                            name="fav_language"
                                                            disabled={action === 2 && !editMode}
                                                            value="N"
                                                            checked={partnerModel.VatStatus === 'N'}
                                                            onChange={(event) => this.onChangeValueConsolidacion(event)} />
                                                    </div>
                                                </div>
                                                {action === 2 && !editMode ? <input className="form-control" readOnly disabled value="Extranjeros" />
                                                    : <label className="form-control" htmlFor="idExt"> Extranjeros </label>
                                                }
                                            </div>
                                        </div>

                                        {/* EORI Number */}
                                        <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <label className="input-group-text font-weight-bold" htmlFor="fldEORINumber"> Número EORI </label>
                                                </div>
                                                <input
                                                    id="fldEORINumber"
                                                    className="form-control"
                                                    disabled={action === 2 && !editMode}
                                                    value={partnerModel.EORINumber || ""}
                                                    onChange={({ target: { value } }) => this.changeBPField("EORINumber", value, 15)} />
                                            </div>
                                        </div>

                                        {/* WTLiable */}
                                        <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text font-weight-bold">
                                                        <input
                                                            id="fldWTLiable"
                                                            type="checkbox"
                                                            disabled={action === 2 && !editMode}
                                                            checked={partnerModel.WTLiable}
                                                            onChange={this.onChangeRetencion} />
                                                    </div>
                                                </div>
                                                {action === 2 && !editMode ? <input className="form-control" readOnly disabled value="Sujeto a retención" />
                                                    : <label className="form-control" htmlFor="fldWTLiable"> Sujeto a retención </label>
                                                }
                                            </div>
                                        </div>

                                        {/* WTLiable Fields */}
                                        {!partnerModel.WTLiable ? <></> : <>
                                            <div className="col-12 col-md-6">
                                                {/* Certificate NO */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <label className="input-group-text font-weight-bold" htmlFor="fldCrtfcateNO"> Número de Certificado </label>
                                                    </div>
                                                    <input
                                                        id="fldCrtfcateNO"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={partnerModel.CrtfcateNO || ""}
                                                        onChange={({ target: { value } }) => this.changeBPField("CrtfcateNO", value, 20)} />
                                                </div>

                                                {/* Expire Date */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <label className="input-group-text font-weight-bold" htmlFor="fldExpireDate"> Fecha de Vencimiento </label>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        id="fldExpireDate"
                                                        className="form-control text-right"
                                                        disabled={action === 2 && !editMode}
                                                        value={partnerModel.ExpireDate || ""}
                                                        onChange={({ target: { value } }) => this.changeBPField("ExpireDate", value)}
                                                        onBlur={() => this.validateDateField("ExpireDate", "Fecha de Vencimiento", partnerModel.ExpireDate)} />
                                                </div>

                                                {/* ITW Codes */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <label className="input-group-text font-weight-bold" htmlFor="fldITWCodes"> ITW Código Permitido </label>
                                                    </div>
                                                    <button id="fldITWCodes" type="button" className="btn btn-outline-warning" onClick={() => this.openTaxWithholdingModal("I")}> <i className="fa fa-list" /> </button>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6">
                                                {/* IVA Codes */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <label className="input-group-text font-weight-bold" htmlFor="fldIVACodes"> Código IVA Permitido </label>
                                                    </div>
                                                    <button id="fldIVACodes" type="button" className="btn btn-outline-warning" onClick={() => this.openTaxWithholdingModal("V")}> <i className="fa fa-list" /> </button>
                                                </div>

                                                {/* Consolidación Obligatorio */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text font-weight-bold">
                                                            <input
                                                                id="fldAccCritriaY"
                                                                type="radio"
                                                                name="rAccCritria"
                                                                disabled={action === 2 && !editMode}
                                                                checked={partnerModel.AccCritria === 'Y'}
                                                                onChange={() => this.changeBPField("AccCritria", "Y")} />
                                                        </div>
                                                    </div>
                                                    {action === 2 && !editMode ? <input className="form-control" readOnly disabled value="Periodificación Anticipada" />
                                                        : <label className="form-control" htmlFor="fldAccCritriaY"> Periodificación Anticipada </label>
                                                    }
                                                </div>

                                                {/* Consolidación Extranjeros */}
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text font-weight-bold">
                                                            <input
                                                                id="fldAccCritriaN"
                                                                type="radio"
                                                                name="rAccCritria"
                                                                disabled={action === 2 && !editMode}
                                                                checked={partnerModel.AccCritria === 'N'}
                                                                onChange={() => this.changeBPField("AccCritria", "N")} />
                                                        </div>
                                                    </div>
                                                    {action === 2 && !editMode ? <input className="form-control" readOnly disabled value="Fondos en Efectivo" />
                                                        : <label className="form-control" htmlFor="fldAccCritriaN"> Fondos en Efectivo </label>
                                                    }
                                                </div>
                                            </div>
                                        </>}

                                        {/* TAX Code */}
                                        {/* <div className="col-12 col-md-6">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidacion">Indicador de impuestos</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={partnerModel.TaxCode ? `${partnerModel.TaxCode} - ${partnerModel.TaxName}` : ""}
                                                    id="txtTel21" />
                                                {!(action === 2 && !editMode) &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-warning"
                                                        onClick={() => this.openTaxes('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                }
                                            </div>
                                        </div> */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Finanzas */}
                    <div className="container tab-pane fade"
                        id="DatosMaestrosAnexos"
                        role="datosAnexos"
                        aria-labelledby="nav-profile-tab-Direcciones" >
                        <div className="table-responsive mb-3">
                        <table className="w-100" id="dataTableDocuments">
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <th className="table-header-yellow sticky-header p-2"> Nombre </th>
                                    <th className="table-header-yellow sticky-header p-2"> Fecha </th>
                                    <th className="table-header-yellow sticky-header p-2"> Acciones </th>
                                </tr>
                            </thead>
                            <tbody>
                                {(!Array.isArray(partnerModel.Attachments) || (!partnerModel?.Attachments?.length)) ?
                                    <tr>
                                        <td className={`dt-row-primary p-2 text-center`} colSpan={3}> No hay archivos anexos </td>
                                    </tr>
                                    : partnerModel.Attachments.map((atc, index) =>
                                        <tr index={`BPAttachment-${index}`}>
                                            <td className={`dt-row-${index % 2 === 0 ? "primary" : "secondary"} p-2 text-left`} style={{ maxWidth: 200 }}> {atc.FileName} </td>
                                            <td className={`dt-row-${index % 2 === 0 ? "primary" : "secondary"} p-2 text-center`} style={{ maxWidth: 200 }}> {moment(atc.Date).format("YYYY/MM/DD")} </td>
                                            <td className={`dt-row-${index % 2 === 0 ? "primary" : "secondary"} p-2 text-center`} style={{ maxWidth: 200 }}>
                                                {action === 2 && !editMode ?
                                                    <button type="button" className="btn btn-outline-primary mr-2" onClick={() => downloadAttachmentsFiles(atc)}> <i className="fas fa-download mr-2" /> Descargar </button>
                                                    : <button type="button" className="btn btn-outline-danger" onClick={() => this.removeAttachments(index)}> <i className="fas fa-trash" /> </button>
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        </div>
                        {!(action === 2 && !editMode) &&
                            (Array.isArray(partnerModel.Attachments) ? !(partnerModel.Attachments.filter(({ AbsEntry }) => !AbsEntry)).length : true) ? // Validar que no haya cargado archivos previamente, JS no permite subir en dos selecciones diferentes
                            <label className="btn btn-outline-success" style={{ width: 250, borderColor: "#A7A6A5" }}>
                                <i className="fas fa-upload mr-2" /> Subir Archivo
                                <input onChange={({ target }) => this.uploadAttachments(target)} type="file" multiple style={{ display: 'none' }} />
                            </label> : <></>
                        }
                        {/* Campos de documentos */}
                        {[
                            { id: 'BPG40', field: 'U_RS_Doc1', label: 'Ficha RUC', labelShort: 'Ficha RUC' },
                            { id: 'BPG41', field: 'U_RS_Doc2', label: 'Formato solicitud línea de crédito', labelShort: 'Solic Línea Crédito' },
                            { id: 'BPG42', field: 'U_RS_Doc3', label: 'Vigencia poder representante legal', labelShort: 'Vigencia Rep Legal' },
                            { id: 'BPG43', field: 'U_RS_Doc4', label: 'DNI/CE', labelShort: 'DNI/CE' },
                            { id: 'BPG44', field: 'U_RS_Doc5', label: 'Declaración jurada anual', labelShort: 'Decl Jurada' },
                            { id: 'BPG45', field: 'U_RS_Doc6', label: 'PDT mensual', labelShort: 'PDT Mensual' }
                        ].map(({ id, field, label, labelShort }) => {
                            const docValue = partnerModel[field];

                            // Validar que no sea vacío de ninguna forma
                            const isValidValue = docValue &&
                                docValue !== '' &&
                                docValue !== 'null' &&
                                docValue !== 'undefined';

                            const isStoredFile = isValidValue &&
                                typeof docValue === 'string' &&
                                docValue.includes('\\');

                            const isFileObject = isValidValue && docValue instanceof File;
                            const hasDocument = isStoredFile || isFileObject;
                            const isDisabled = action === 2 && !editMode;
                            const fileName = isStoredFile
                                ? docValue.split('\\').pop()
                                : docValue?.name;

                            return (
                                <div key={field} className="input-group mb-2" id={id}>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold py-1">
                                            <span className="d-none d-xl-inline">{label}</span>
                                            <span className="d-inline d-xl-none">{labelShort}</span>
                                        </span>
                                    </div>
                                    {isStoredFile ?
                                        <>
                                            <span className="form-control py-1 text-truncate" style={{ backgroundColor: '#e9ecef' }}>
                                                {fileName}
                                            </span>
                                            {/* <button type="button" className="btn btn-outline-info" onClick={() => this.downloadUDFAttachment({ FilePath: docValue, FileName: fileName })}>
                                                <i className="fas fa-download mr-2" /> Descargar
                                            </button> */}
                                        </>
                                        : isFileObject ?
                                            <span className="form-control py-1 text-truncate" title={fileName}>
                                                {fileName}
                                            </span>
                                            :
                                            <input type="file" className="form-control py-1" disabled={isDisabled} accept=".pdf" onChange={(e) => this.handleDocumentChange(field, e.target.files[0])} />
                                    }

                                    {hasDocument && !isDisabled && (
                                        <button type="button" className="btn btn-outline-danger" onClick={() => this.removeDocument(field, fileName)} title="Eliminar documento">
                                            <i className="fas fa-trash" />
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        )
    }
    handleMapSelect = (lat, lng) => {
        const { typeSelectionAddress } = this.state
        if (lat != null && lng != null && typeSelectionAddress != null) {
            this.changeAddressValue(lat, 'U_FMB_GPSLat', typeSelectionAddress);
            this.changeAddressValue(lng, 'U_FMB_GPSLon', typeSelectionAddress);
            this.changeBlurAddressValue(lat, 'U_FMB_GPSLat', typeSelectionAddress);
            this.changeBlurAddressValue(lng, 'U_FMB_GPSLon', typeSelectionAddress);
        }
    }

    closeModalMap = () => {
        this.setState({ showMap: false, currSelectionAddress: null, typeSelectionAddress: null });
    };

    render() {
        const {
            action,
            partnerModel,
            view,
            showAlert,
            enableSpinner,
            refreshModel,
        } = this.props;

        const {
            editMode,
            groupCodes,
            cardTypes,
            currencies,
            employees,
            groupNums,
            prices,
            territories,
            contactPersons,
            addresses,
            countries,
            states,
            taxes,
            payMethods,
            CardCodeBalance,
            AccountBalan,
            AccountBalanceData,
            cardCodeReferenceList,
            accounts,
            groupCodesModal,
            showMap,
            currSelectionAddress,
            showTaxesModal,
            taxesModalInfo,
            projects,
        } = this.state;

        return (
            <div
                id="BussinesPartner"
                className="modal fade bd-example-modal-xl modal-open scroll"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                <BankAccountModal
                    enableSpinner={enableSpinner}
                    showAlert={showAlert}
                    partnerModel={partnerModel}
                    refreshModel={refreshModel}
                    deleteBank={this.deleteBank}
                    selectBankDefault={this.selectBankDefault}
                    changeAccountBank={this.changeAccountBank}
                    changeControlKeyBank={this.changeControlKeyBank}
                    changeBranchBank={this.changeBranchBank}
                    changeIBANBank={this.changeIBANBank}
                    changeSwiftNumBank={this.changeSwiftNumBank}
                    cleanData={() => this.setState({ addresses: [] })} />

                <AccountBalancePartner
                    CardCodeBalance={CardCodeBalance}
                    AccountBalan={AccountBalan}
                    newOrderModel={partnerModel}
                    AccountBalanceData={AccountBalanceData}
                    openAccountBalance={this.openAccountBalance} />

                <UserFieldsPartnerModal
                    newOrderModel={partnerModel}
                    action={action}
                    refreshModel={this.refreshModel}
                    view={view}
                    editMode={editMode} />

                <PayMethodModal
                    data={payMethods}
                    selectpayMethod={this.selectPayMethod}
                    cleanData={() => this.setState({ payMethods: [] })} />

                <ImpuestoPartnerModal
                    data={taxes}
                    selectTaxe={this.selectTaxes}
                    cleanData={() => this.setState({ taxes: [] })} />

                <ProjectsPartnerModal
                    data={projects}
                    selectProject={this.selectProject}
                    cleanData={() => this.setState({ projects: [] })} />

                <StatesModal
                    data={states}
                    selectCountry={this.selectState}
                    cleanData={() => this.setState({ states: [] })} />

                <CountryModal
                    data={countries}
                    selectCountry={this.selectCountry}
                    cleanData={() => this.setState({ countries: [] })} />

                <ContactPersonsPartnerModal
                    data={contactPersons}
                    selectContactPersons={this.selectContactPersons}
                    deleteContactPersons={this.deleteContactPersons}
                    cleanData={() => this.setState({ contactPersons: [] })} />

                <AddressesPartnerModal
                    data={addresses}
                    selectAddresses={this.selectAddresses}
                    deleteAddresses={this.deleteAddresses}
                    cleanData={() => this.setState({ addresses: [] })} />

                <GroupCodeModal
                    data={groupCodes}
                    selectGroupCode={this.selectGroupCode}
                    cleanData={() => this.setState({ groupCodes: [] })}
                    OpenGroupCode={this.openGroupCode}
                    DisableModal={() => { this.setState({ groupCodesModal: false }); this.forceUpdate() }}
                    GroupCodesModal={groupCodesModal} />

                <CardCodeReferenceCreationModal
                    data={cardCodeReferenceList}
                    cleanData={() => this.setState({ cardCodeReferenceList: [] })} />

                <TerritoriesModal
                    data={territories}
                    selectTerritories={this.selectTerritories}
                    cleanData={() => this.setState({ territories: [] })} />

                <CardTypeModal
                    data={cardTypes}
                    selectCardType={this.selectCardType}
                    cleanData={() => this.setState({ cardTypes: [] })} />

                <CurrencyModal
                    data={currencies}
                    selectCurrency={this.selectCurrency}
                    cleanData={() => this.setState({ currencies: [] })} />

                <EmployeeSalesPartnerModal
                    data={employees}
                    selectEmployee={this.selectEmployee}
                    cleanData={() => this.setState({ employees: [] })} />

                <GroupNumModal
                    data={groupNums}
                    selectGroupNum={this.selectGroupNum}
                    cleanData={() => this.setState({ groupNums: [] })} />

                <PriceListPartnerModal
                    data={prices}
                    selectPriceList={this.selectPriceList}
                    cleanData={() => this.setState({ prices: [] })} />
                <AccountListPartnerModal
                    data={accounts}
                    selectAccount={this.selectAccountList}
                    cleanData={() => this.setState({ accounts: [] })} />

                {showTaxesModal &&
                    <StandardSelectModal
                        id="TaxesModal"
                        title={taxesModalInfo.title || "Selección"}
                        headers={[
                            { title: "Código", value: true, filter: true, field: "Code" },
                            { title: "Descripción", value: true, filter: true, field: "Name" },
                        ]}
                        data={Array.isArray(taxesModalInfo.data) ? taxesModalInfo.data : []}
                        selectAction={typeof (taxesModalInfo.action) === "function" ? taxesModalInfo.action : () => { }}
                        selectedItems={Array.isArray(taxesModalInfo.selection) ? taxesModalInfo.selection : []}

                        disabled={action === 2 && !editMode}
                        selection="multiple"
                        idSelection="Code"
                        warningQtySelection={50}
                        limitQtySelection={100}
                        validNoSelection={true} />
                }

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        {showMap && (
                            <div
                                className="modal show"
                                style={{
                                    display: "block",
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                }}
                            >
                                <div className="modal-dialog modal-lg modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Seleccionar ubicación</h5>
                                            <button type="button" className="btn-close" onClick={this.closeModalMap}></button>
                                        </div>
                                        <div className="modal-body" style={{ height: "70vh" }}>
                                            <SelectionMap onSelect={this.handleMapSelect} currPosition={[(currSelectionAddress?.U_FMB_GPSLat ?? null), (currSelectionAddress?.U_FMB_GPSLon ?? null)]} />
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-secondary" onClick={this.closeModalMap}>
                                                Cerrar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            {(view === "bussinesPartner") && <h4 className="modal-title" id="modal-basic-title ">DATOS MAESTROS DE SOCIO DE NEGOCIOS</h4>}
                            {(view === "inventoryData") && <h4 className="modal-title" id="modal-basic-title ">DATOS MAESTROS DE ARTÍCULO</h4>}
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true"> &times; </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.renderSelector()}
                            {this.renderEditButton()}
                            {this.renderBussinesHeader()}
                            {this.renderBussinesBody()}
                            {/* <h4><label htmlFor="txtName" className="font-weight-bold" style={{color: '#6c757d'}}>CONDICIONES DE
                                PAGO: </label> </h4>
                            {this.renderBussinesFooter()} */}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar
                            </button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black"
                                onClick={this.sendModel}> Crear</button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.ValidateAll(this.acceptEditMode)}>
                                    Guardar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
}

export default BussinesPartnerModal;